import { Component, OnInit, ViewChild, ElementRef, Input, Output, TemplateRef, Pipe, PipeTransform, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';
import { SalesBillentryService, CommonService, SubscribeService, ChallanOutService, } from '../../../services/index';
import { SalesBillentryModel, ClientModel, EmployeeModel } from '../../../model/index';
import { AddEditEmiDetailsComponent } from './addEditEmiDetails.component';


@Component({
    selector: 'addeditsalesbillentry-tab',
    changeDetection: ChangeDetectionStrategy.Default,
    templateUrl: './addEditSalesBillentry.component.html',
})
export class AddEditSalesBillentryComponent implements OnInit, AfterViewInit {
    private searchTerms = new Subject<string>();
    private searchTermsEmp = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }

    public mode: string;
    public list: any[] = [];
    //public salesbilltypesdata: any[] = [];

    isLoadMask: Promise<any>;
    //salesbilltypesData: SalesBillentryModel[];
    isLoading: boolean = false;
    minDate: any;
    filteredSrc: Observable<any[]>;
    filteredBranch: Observable<any[]>;

    @Input() salesBillgriddata: SalesBillentryModel[] = [];
    @Input() salesbillentrydata: SalesBillentryModel[] = [];
    potCusCtrl: FormControl;
    transTypeCtrl: FormControl;
    machineTypeCtrl: FormControl;
    warrantyPeriodCtrl: FormControl;
    advanceTypeCtrl: FormControl;
    srclistCtrl: FormControl;
    store_hvCtrl: FormControl;
    halistCtrl: FormControl;
    serialNoCtrl: FormControl;
    // hsnCtrl: FormControl;
    // filteredHa: Observable<any[]>;
    filteredHa: Observable<any[]>;

    // filteredHsn: Observable<any[]>;
    filteredSalesRetBill: Observable<any[]>;
    filteredTypes: Observable<any[]>;
    filteredSerialNo: Observable<any[]>;
    // filteredSerialNo: any[] = [];

    clientCtrl: FormControl;
    filteredItems: Observable<any[]>;
    salesRetBillCtrl: FormControl;
    testingtypeCtrl: FormControl;
    branchCtrl: FormControl;
    filteredBrandModel: Observable<any[]>;
    filteredBrand: Observable<any[]>;
    filteredFamily: Observable<any[]>;
    filteredSeries: Observable<any[]>;
    filteredPower: Observable<any[]>;
    filteredPerformance: Observable<any[]>;
    filteredBattery: Observable<any[]>;
    brandModelList$: any[] = [];
    brandModelCtrl: FormControl;
    brandList$: any[] = [];
    brandCtrl: FormControl;
    familyList$: any[] = [];
    seriesList$: any[] = [];
    powerList$: any[] = [];
    performanceList$: any[] = [];
    batteryList$: any[] = [];
    familyCtrl: FormControl;
    seriesCtrl: FormControl;
    powerCtrl: FormControl;
    performanceCtrl: FormControl;
    batteryCtrl: FormControl;
    paymentListCtrl: FormControl;

    @ViewChild('halistAutoCompSpr') halistAutoCompSpr;
    @ViewChild('clientAutoComp') clientAutoComp;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('searchComponent') searchComponent;

    potCusOptList: any[];
    transTypeList: any[];
    machineTypeList: any[];
    advanceTypeList: any[];
    store_hvOptList: any[];
    haList: any[] = [];
    acthaList: any[] = [];
    salesReturnList: any[] = [];
    warrantyList: any = []
    clientList: any[] = [];
    serialNoList: any[] = [];
    testTravelRes: any[] = [];
    reorderable: boolean = true;
    advCheck: boolean = true;
    page = {
        limit: 20,
        count: 0,
        offset: 0,
        orderBy: 'bill_id',
        orderDir: 'asc'
    };
    columns = [];
    salesBillentryDetails = [];
    totalDetails = [];
    actSerialNoList = [];
    srcList: any[] = [];
    // hsnList: any[] = [];
    emiDetails = [];
    emplistCtrl: FormControl;
    cliCtrl: FormControl;
    filteredEmp: Observable<any[]>;
    @ViewChild('emplistAutoComp') emplistAutoComp;
    empList: any[] = [];
    clientHVList: any[] = [];
    freeCtrl: FormControl;
    rocCouponCtrl: FormControl;
    freeList = [];
    rocCouponList = [];
    testingList: any[] = [];
    branchList: any[] = [];
    paymentList: any[];
    isEditMode: boolean = false;

    // Redemption properties
    clientAvailablePoints: number = 0;
    @ViewChild('redeemPointsModal') redeemPointsModal: TemplateRef<any>;
    redeemModalRef: BsModalRef;
    redemptionData: any = {
        mobile: '',
        customer_name: '',
        client_no: '',
        total_points: 0,
        points_worth: 0,
        min_redeem_points: 0,
        min_bill_amount: 0,
        max_bill_amount: 0,
        redeem_value: 0,
        max_redeemable_points: 0,
        points_to_redeem: 0,
        discount_amount: 0
    };
    financialYear: string = '';
    otpSent: boolean = false;
    otpVerified: boolean = false;
    otpValue: string = '';
    // Coupon code properties
    couponOtpSent: boolean = false;
    couponOtpVerified: boolean = false;
    couponOtpValue: string = '';
    couponCodeInput: string = '';
    couponDiscountType: string = 'Amount';
    couponDiscountPercentage: number = 0;

    constructor(public store: Store<fromRootStore.State>, private modalService: BsModalService, private salesBillentryService: SalesBillentryService, private commonService: CommonService, public snackBar: MdSnackBar, public toasterService: ToasterService, public subscribeService: SubscribeService, private challanoutService: ChallanOutService, public changeDetector: ChangeDetectorRef) {
        //this.halistCtrl = new FormControl();
        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidFree(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidFree: true };
            }

            return retVal;
        }
        this.freeCtrl = new FormControl('', [
            Validators.required,
            hasValidFree.bind(this)
        ]);
        this.freeList = ['Yes', 'No'];

        function hasValidRoc(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Yes" && ledgerID != "No") {
                retVal = { inValidRoc: true };
            }

            return retVal;
        }
        this.rocCouponCtrl = new FormControl('', [
            Validators.required,
            hasValidRoc.bind(this)
        ]);
        this.rocCouponList = ['Yes', 'No'];

        function hasValidEmp(input: FormControl) {
            let empid = input.value;
            let femp = _.find(this.empList, { 'empid': empid });
            if (femp)
                return null;
            return { inValidEmp: true };
        }
        this.emplistCtrl = new FormControl('', [
            Validators.required,
            hasValidEmp.bind(this)

        ]);
        //FOR AUTO COMPLETE VALIDATION --- 
        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;

            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.halistCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);

        // function hasValidHaModel(input: FormControl) {
        //     let ModelID = input.value, retVal = null;

        //     if (ModelID == "") {
        //         retVal = { inValidHaModel: true };
        //     }
        //     if (ModelID && typeof ModelID === 'string') {
        //         retVal = { inValidHaModel: true };
        //     }
        //     return retVal;
        // }
        this.salesRetBillCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);

        function hasValidModel(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidModel: true };
            }
            return retVal;
        }
        // function hasValidHsn(input: FormControl) {
        //     let HsnID = input.value, retVal = null;
        //     if (HsnID == "") {
        //         retVal = { inValidHsn: true };
        //     }
        //     if (HsnID && typeof HsnID === 'string') {
        //         retVal = { inValidHsn: true };
        //     }
        //     return retVal;
        // }
        this.clientCtrl = new FormControl('', [
            Validators.required,
            hasValidModel.bind(this)
        ]);

        // this.hsnCtrl = new FormControl('', [
        //     Validators.required,
        //     hasValidHsn.bind(this)
        // ]);

        // this.filteredHsn = this.hsnCtrl.valueChanges
        //     .startWith(null)
        //     .map(name => name ? this.filterHsn(name) : this.hsnList.slice());







        /// old conde
        const haSubject = new Subject<any>();
        this.filteredHa = haSubject.asObservable();

        const serialNoSubject = new Subject<any>();
        this.filteredSerialNo = serialNoSubject.asObservable();

        this.halistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice())
            .subscribe((x) => {
                console.log('ON search>>>>', x);
                haSubject.next(x);
            })
        // this.serialNoCtrl = new FormControl();
        this.serialNoCtrl = new FormControl();

        // this.halistCtrl.valueChanges
        //     .subscribe((x) => {
        //         if(this.salesBillgriddata['free_item'] == 'Yes' || (this._params['tabParams'] == 'Spare Bill' && this.salesBillgriddata['free_item'] == 'No')) {
        //            let items =  this.actSerialNoList.filter(a => a.model_id == x.model_id);
        //            this.serialNoList = items;
        //         }
        //     })

        this.serialNoCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSerialNo(name) : this.haList.slice())
            .subscribe(x => {
                // console.log('ON CHAGE>>>>', this.salesBillgriddata['free_item']);
                if (this.salesBillgriddata['free_item'] == 'No') {
                    // this.halistCtrl.reset();
                    serialNoSubject.next(x);
                    return x;
                }

            })

        // this.halistCtrl.valueChanges
        // .subscribe((x) => {
        //     if(this.salesBillgriddata['free_item'] == 'Yes') {
        //        let items =  this.actSerialNoList.filter(a => a.model_id == x.model_id);
        //        this.serialNoList = items;
        //     }
        // })

        this.filteredSalesRetBill = this.salesRetBillCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSalesRetBill(name) : this.salesReturnList.slice());
        this.filteredSerialNo = this.serialNoCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSerialNo(name) : this.serialNoList.slice());
        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        // function hasValidType(input: FormControl) {
        //     let ledgerID = input.value, retVal = null;
        //     if (ledgerID != "CASH" && ledgerID != "CREDIT" && ledgerID != "CARD"
        //         && ledgerID != "CHEQUE" && ledgerID != "ONLINE" && ledgerID != "CASH&CARD") {
        //         retVal = { inValidType: true };
        //     }

        //     return retVal;
        // }
        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidTransType(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Normal" && ledgerID != "Exchange" && ledgerID != "Replacement"
                && ledgerID != "Trial" && ledgerID != "Service New Machine") {
                retVal = { inValidType: true };
            }

            return retVal;
        }
        function hasValidPaymentType(input: FormControl) {
            let paymentID = input.value, retVal = null;
            if (paymentID != "Bajaj Finance" && paymentID != "Self" && paymentID != "Others") {
                retVal = { inValidType: true };
            }

            return retVal;
        }
        this.potCusCtrl = new FormControl();
        this.transTypeCtrl = new FormControl('', [
            Validators.required,
            hasValidTransType.bind(this)
        ]);
        this.paymentListCtrl = new FormControl('', [
            Validators.required,
            hasValidPaymentType.bind(this)
        ]);

        //FOR MACHINE TYPE
        function hasValidMachineType(input: FormControl) {
            let val = input.value, retVal = null;
            if (val != "Single" && val != "Bilateral") {
                retVal = { invalidType: true };
            }
            return retVal;
        }
        this.machineTypeCtrl = new FormControl('', [
            Validators.required,
            hasValidMachineType.bind(this)
        ]);

        //For Warranty Period
        function hasValidWarrantyType(input: FormControl) {
            let val = input.value, retVal = null;
            if (val != "1 Year" && val != "2 Years" && val != "2.5 Years") {
                retVal = { invalidType: true };
            }
            return retVal;
        }
        this.warrantyPeriodCtrl = new FormControl('', [
            Validators.required,
            hasValidWarrantyType.bind(this)
        ]);

        function hasValidAdvTransType(input: FormControl) {
            let val = input.value, retVal = null;
            if (val != "Normal" && val != "New Order" && val != "Mould") {
                retVal = { inValidType: true };
            }
            return retVal;
        }
        this.advanceTypeCtrl = new FormControl('', [
            Validators.required,
            hasValidAdvTransType.bind(this)
        ]);

        this.potCusOptList = ['CASH', 'CREDIT', 'CARD', 'CHEQUE', 'ONLINE'];
        this.paymentList = ['Bajaj Finance', 'Self', 'Others'];
        // function hasValidType(input: FormControl) { 
        function hasValidStore(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "STORE" && ledgerID != "HV" && ledgerID != "SOA") {
                retVal = { inValidStatus: true };
            }

            return retVal;
        }
        this.store_hvCtrl = new FormControl('', [
            Validators.required,
            hasValidStore.bind(this)
        ]);
        //  this.potCusCtrl = new FormControl();
        this.store_hvOptList = ['STORE', 'HV', 'SOA'];
        //this.clientCtrl = new FormControl();
        //  this.emplistCtrl = new FormControl();
        function hasValidHvClient(input: FormControl) {
            let clientID = input.value;
            let femp = _.find(this.clientHVList, { 'client_id': clientID });
            if (femp)
                return null;
            return { inValidHvClient: true };
        }
        this.cliCtrl = new FormControl('', [
            Validators.required,
            hasValidHvClient.bind(this)
        ]);
        // this.cliCtrl = new FormControl();

        function hasSrc(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidSRC: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidSRC: true };
            }
            return retVal;
        }
        this.srclistCtrl = new FormControl('', [
            Validators.required,
            hasSrc.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredSrc = this.srclistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSrc(name) : this.srcList.slice());

        function hasValidTestType(input: FormControl) {
            let testTypeID = input.value, retVal = null;
            if (testTypeID == "") {
                retVal = { inValidTestType: true };
            }
            if (testTypeID && typeof testTypeID === 'string') {
                retVal = { inValidTestType: true };
            }
            return retVal;
        }
        this.testingtypeCtrl = new FormControl('', [
            Validators.required,
            hasValidTestType.bind(this)
        ]);

        this.filteredTypes = this.testingtypeCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterTypes(name) : this.testingList.slice());

        // this.branchCtrl = new FormControl();
        this.branchCtrl = new FormControl('', [
            Validators.required,
            hasValidBranch.bind(this)
        ]);
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        function hasValidBranch(input: FormControl) {
            let branchID = input.value, retVal = null;
            if (branchID && typeof branchID === "string") {
                retVal = { inValidBranch: true };
            }
            return retVal;
        }

        // let that = this;
        // this.commonService
        // .loadClientList_all()
        // .then(function (res: any) {
        //     if (res.success) {
        //         that.clientList = res.data;
        //     }
        // });
        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidBrandModel(input: FormControl) {
            let brandModelID = input.value, retVal = null;
            if (brandModelID == "") {
                retVal = { inValidBrandModel: true };
            }
            if (brandModelID && typeof brandModelID === 'string') {
                retVal = { inValidBrandModel: true };
            }
            return retVal;
        }
        this.brandModelCtrl = new FormControl('', [
            Validators.required,
            hasValidBrandModel.bind(this)
        ]);
        this.filteredBrandModel = this.brandModelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrandModel(name) : this.brandModelList$.slice());
        //FOR AUTO COMPLETE VALIDATION --- BRAND COMBO
        function hasValidBrand(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidBrand: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidBrand: true };
            }
            return retVal;
        }
        this.brandCtrl = new FormControl('', [
            Validators.required,
            hasValidBrand.bind(this)
        ]);
        this.filteredBrand = this.brandCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrand(name) : this.brandList$.slice());

        //FOR AUTO COMPLETE VALIDATION --- FAMILY COMBO
        function hasValidFamily(input: FormControl) {
            let familyID = input.value, retVal = null;
            if (familyID == "") {
                retVal = { inValidFamily: true };
            }
            if (familyID && typeof familyID === 'string') {
                retVal = { inValidFamily: true };
            }
            return retVal;
        }
        this.familyCtrl = new FormControl('', [
            Validators.required,
            hasValidFamily.bind(this)
        ]);
        this.filteredFamily = this.familyCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterFamily(name) : this.familyList$.slice());

        //Series
        function hasValidSeries(input: FormControl) {
            let seriesID = input.value, retVal = null;
            if (seriesID && typeof seriesID === 'string') {
                retVal = { inValidSeries: true };
            }
            return retVal;
        }
        this.seriesCtrl = new FormControl('', hasValidSeries.bind(this));

        this.filteredSeries = this.seriesCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSeries(name) : this.seriesList$.slice());

        //Performance
        function hasValidPerformance(input: FormControl) {
            let performanceID = input.value, retVal = null;
            if (performanceID && typeof performanceID === 'string') {
                retVal = { inValidPerformance: true };
            }
            return retVal;
        }
        this.performanceCtrl = new FormControl('', hasValidPerformance.bind(this));

        this.filteredPerformance = this.performanceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterPerformance(name) : this.performanceList$.slice());

        //Power
        function hasValidPower(input: FormControl) {
            let powerID = input.value, retVal = null;
            if (powerID && typeof powerID === 'string') {
                retVal = { inValidPower: true };
            }
            return retVal;
        }
        this.powerCtrl = new FormControl('', hasValidPower.bind(this));
        this.filteredPower = this.powerCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterPower(name) : this.powerList$.slice());

        //Battery
        function hasValidBattery(input: FormControl) {
            let batteryID = input.value, retVal = null;
            if (batteryID && typeof batteryID === 'string') {
                retVal = { inValidBattery: true };
            }
            return retVal;
        }
        this.batteryCtrl = new FormControl('', hasValidBattery.bind(this));
        this.filteredBattery = this.batteryCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBattery(name) : this.batteryList$.slice());

    }

    ngOnInit(): void {
        let that = this;
        let serialNoColWidth = 180;
        this.transTypeList = ['Normal', 'Trial', 'Service New Machine']; //['Normal', 'Exchange', 'Replacement', 'Trial'];
        this.machineTypeList = ['Single', 'Bilateral'];
        this.advanceTypeList = ['Normal', 'New Order', 'Mould'];
        //this.warrantyList = ['1 Year', '2 Years', '2.5 Years'];
        this.loadSrcList();
        this.salesbillentrydata['oldadvances'] = '';
        this.salesbillentrydata['redeem_points_opted'] = false;
        this.salesbillentrydata['redeem_discount'] = 0;
        this.salesbillentrydata['roc_coupon_give'] = 'no'; // Default value for ROC Coupon Give
        this.salesBillgriddata['roc_coupon_give'] = 'No'; // Default value for grid data
        this.otpSent = false;
        this.otpVerified = false;
        this.otpValue = '';
        this.salesbillentrydata['coupon_opted'] = false;
        this.salesbillentrydata['coupon_discount'] = 0;
        this.couponOtpSent = false;
        this.couponOtpVerified = false;
        this.couponOtpValue = '';
        this.couponCodeInput = '';
        if (this.salesbillentrydata['tabParams'] != 'HV' && this.salesbillentrydata['tabParams'] != 'SOA') {
            this.loadChallanHaList();
        }

        if (this.salesbillentrydata['tabParams'] == 'Advance' || this.salesbillentrydata['tabParams'] == 'EMI') {
            this.potCusOptList = ['CASH', 'CARD', 'CHEQUE', 'ONLINE', 'CREDIT'];
        } else if (this.salesbillentrydata['tabParams'] == 'Spare Bill') {
            this.potCusOptList = ['CASH', 'CARD', 'ONLINE', 'CHEQUE', 'CREDIT'];
            serialNoColWidth = 90;
        }

        // TO GET USER TYPE
        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin'] && auth['usertype'] == 'User') {
                this.salesbillentrydata['branch'] = auth['branch_id'];
                this.branchCtrl.disable();
            }
        });

        // this.halistAutoComp.optionSelected.subscribe(this.onSelectedHaList.bind(this));

        this.columns = [
            { name: 'SNo', prop: 'sno', width: 50, minWidth: 50, maxWidth: 50, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Free', prop: 'free_item', width: 55, minWidth: 55, maxWidth: 55, sortable: false, cellClass: 'cell-left' },
            { name: 'Model', prop: 'name', width: 180, minWidth: 180, maxWidth: 180, sortable: false, cellClass: 'cell-left' },
            { name: 'Serial No', prop: 'serial_no', width: serialNoColWidth, minWidth: serialNoColWidth, maxWidth: serialNoColWidth, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand', prop: 'brand_name', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand Model', prop: 'brand_model_name', width: 150, minWidth: 150, maxWidth: 150, sortable: false, cellClass: 'cell-left' },
            { name: 'Family', prop: 'family_name', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Series', prop: 'series_name', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Performance', prop: 'performance_name', width: 150, minWidth: 150, maxWidth: 150, sortable: false, cellClass: 'cell-left' },
            { name: 'Power', prop: 'power_name', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Battery', prop: 'battery_name', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Color', prop: 'color_name', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'Tele Audiology', prop: 'tele_audiology', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            // { name: 'HSN Code', prop: 'hsn_name', width: serialNoColWidth, minWidth: serialNoColWidth, maxWidth: serialNoColWidth, sortable: false, cellClass: 'cell-left' },
            { name: 'Mod/Sp Branch', prop: 'serialno_branch', width: 130, minWidth: 130, maxWidth: 130, sortable: false, cellClass: 'cell-left' },
            { name: 'Chal.Out.no', prop: 'challan_no', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-left' },
            //{ name: 'warranty Period', prop: 'warranty_type', width: 180, minWidth: 180, maxWidth: 180, sortable: false, cellClass: 'cell-left' },
            { name: 'MRP', prop: 'mrp', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-right' },
            { name: 'Quantity', prop: 'quantity', width: 85, minWidth: 85, maxWidth: 85, sortable: false, cellClass: 'cell-right' },
            { name: 'GST %', prop: 'tax_per', width: 85, minWidth: 85, maxWidth: 85, sortable: false, cellClass: 'cell-right' },
            { name: 'Rate', prop: 'rate', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-right' },
            { name: 'Amount', prop: 'amount', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-right' },
            { name: 'Action', prop: 'sno', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        if (this.salesbillentrydata['tabParams'] != 'HV' && this.salesbillentrydata['tabParams'] != 'SOA') {
            this.columns.splice(11, 2);
        }

        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientList(term, 'salesBillentry')
                // or the observable of empty heroes if there was no search term
                : Observable.of<any[]>([]))
            //.switchMap(term => this.commonService.loadClientList(term, 'tt'))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<any[]>([]);
            });


        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });


        // this.commonService
        // .loadClientList_all()
        // .then(function (res: any) {
        //     if (res.success) {
        //         that.clientList = res.data;
        //     }
        // });

        if (this._params['mode'] == 'Add') {
            this.loadAutoNumber();
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());
            if (this._params['walikin_date']) {
                var fechaLatinFormat = this._params['walikin_date'];
                var datePieces = fechaLatinFormat.split("-");
                var preFinalDate = new Date(parseInt(datePieces[2]), parseInt(datePieces[1]) - 1, parseInt(datePieces[0]));
                this.salesbillentrydata['date'] = preFinalDate;
                if (this._params['page_from'] == "HV Entry" || this._params['page_from'] == "SOA Entry") {
                    this.salesbillentrydata['empid'] = this._params['empname'];
                }
            }
            else if (this._params['disp_date']) {
                var fechaLatinFormat = this._params['disp_date'];
                var datePieces = fechaLatinFormat.split("-");
                var preFinalDate = new Date(parseInt(datePieces[2]), parseInt(datePieces[1]) - 1, parseInt(datePieces[0]));
                this.salesbillentrydata['date'] = preFinalDate;
                // this.salesbillentrydata['date'] = new Date(this._params['disp_date']);
            }
            else {
                if (this._params['page_from'] == "HV Appointment" || this._params['page_from'] == "SOA Appointment") {
                    this.salesbillentrydata['date'] = new Date(this._params['date']);
                    this.salesbillentrydata['reference_name'] = this._params['reference_name'];
                    this.salesbillentrydata['empid1'] = this._params['empname'];
                    this.salesbillentrydata['empid'] = this._params['empname'];
                } else {
                    this.salesbillentrydata['date'] = new Date();
                }

            }

            this.salesbillentrydata['amount'] = 0;
            this.salesBillgriddata['amount'] = 0;
            this.salesbillentrydata['warranty_type'] = '';
            if (this.salesbillentrydata['tabParams'] == 'Spare Bill' || this.salesbillentrydata['tabParams'] == 'Sales Bill' || this.salesbillentrydata['tabParams'] == 'HV' || this.salesbillentrydata['tabParams'] == 'SOA') {
                this.salesBillgriddata['free_item'] = "No";
            }
            if (this._params['transaction_type'] == 'Replacement' || this._params['transaction_type'] == 'Exchange') {
                this.salesbillentrydata['client_no'] = this._params['hidden_client'];
            }
        } else {
            this.isEditMode = true;
            this.potCusCtrl.disable();
            this.salesRetBillCtrl.disable();
        }

        this.filteredEmp = this.searchTermsEmp
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.getEmployeeList(term, 'challan')
                // or the observable of empty heroes if there was no search term
                : Observable.of<EmployeeModel[]>([]))
            //.switchMap(term => this.commonService.getEmployeeList(term, 'tt'))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<EmployeeModel[]>([]);
            });
        this.filteredEmp.subscribe(($e) => {
            that.empList = $e;
        });

        // setTimeout(() => {
        //     $('#type').focus();
        // }, 100);
        //TO DISABLE SERIAL NO FIELD FOR ADVANCE
        // if (this._params['tabParams'] == 'Advance') {
        //     this.serialNoCtrl.disable();
        // }
        //TO LOAD BRANCH MASTER
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                this.store.dispatch(new commonActions.LoadAllBrand());
                this.branchList = res.data;
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['is_hv_center'] == 'false' });
            //this.displayBranchFn(this.clientdata['branch']);
            this.branchCtrl.setValue(this.salesbillentrydata['branch']);
        });

        this.store.select(fromCommonStore.getAllBrandModel).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandModelList$ = res;
                return;
            }
            this.brandModelList$ = res;
        });
        this.store.select(fromCommonStore.getAllBrand).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandList$ = res;
                return;
            }
            this.brandList$ = res;
        });
    }

    showBankField(paymentTypes: any): boolean {
        if (Array.isArray(paymentTypes)) {
            return paymentTypes.includes('CHEQUE') || paymentTypes.includes('ONLINE') || paymentTypes.includes('CARD');
        }
        return paymentTypes === 'CHEQUE' || paymentTypes === 'ONLINE' || paymentTypes === 'CARD';
    }

    requiresChequeNo(paymentTypes: any): boolean {
        if (Array.isArray(paymentTypes)) {
            return paymentTypes.includes('CHEQUE');
        }
        return paymentTypes === 'CHEQUE';
    }

    requiresTransactionNo(paymentTypes: any): boolean {
        if (Array.isArray(paymentTypes)) {
            return paymentTypes.includes('ONLINE');
        }
        return paymentTypes === 'ONLINE';
    }

    hasCashAndCard(paymentTypes: any): boolean {
        if (Array.isArray(paymentTypes)) {
            return paymentTypes.includes('CASH') && paymentTypes.includes('CARD');
        }
        return false;
    }

    getSelectedPaymentTypesDisplay(paymentTypes: any): string {
        if (Array.isArray(paymentTypes)) {
            return paymentTypes.join(', ');
        }
        return paymentTypes || '';
    }

    loadFamilyList() {
        let that = this;
        this.commonService
            .getFamilyList()
            .then(function (res: any) {
                // that.familyList$ = res.data;
                const familydata = res.data.filter(item => item.brand_id === that.salesBillgriddata['brand_id']);
                that.familyList$ = familydata;
                that.familyCtrl.setValue(that.salesBillgriddata['family_id']);
            });
    }

    isSerialNoRequired() {
        if (this._params['tabParams'] == 'Advance') {
            return false;
        } else {
            return true;
        }
    }

    ngAfterViewInit() {
        if (this.salesbillentrydata['tabParams'] == 'Spare Bill') {
            setTimeout(() => {
                this.searchComponent.setType('Spare Bill');
            }, 100);
            this.searchComponent.clientSearchEmit.subscribe(($e) => {
                this.salesbillentrydata['client_id'] = $e['client_id'];
                this.salesbillentrydata['client_name'] = $e['client_name'];
                this.salesbillentrydata['ref_name'] = $e['reference_name'];
                this.salesbillentrydata['hidden_client'] = $e['client_no'];
                this.fetchClientPoints($e['client_id']);
            });
        }
    }

    get disableSaveBtn() {
        if (this.salesbillentrydata['tabParams'] == 'Spare Bill') {
            return this.mode == 'View';
        }
        else if (this.salesbillentrydata['tabParams'] == 'Advance' && this.salesbillentrydata['client_id'] != undefined) {
            return (this.transTypeCtrl.errors && (this.transTypeCtrl.errors.required || this.transTypeCtrl.errors.inValidType)) || (this.advanceTypeCtrl.errors && (this.advanceTypeCtrl.errors.required || this.advanceTypeCtrl.errors.inValidType));
        }

        else if (this.salesbillentrydata['tabParams'] == 'Advance') {
            return (this.clientCtrl.errors && (this.clientCtrl.errors.inValidModel || this.clientCtrl.errors.required))
                || (this.transTypeCtrl.errors && (this.transTypeCtrl.errors.required || this.transTypeCtrl.errors.inValidType))
                || (this.advanceTypeCtrl.errors && (this.advanceTypeCtrl.errors.required || this.advanceTypeCtrl.errors.inValidType))
                || this.mode == 'View';
        }


        else if (this.salesbillentrydata['transaction_type'] == 'Exchange' || this.salesbillentrydata['transaction_type'] == 'Replacement') {
            let validation = (this.clientCtrl.errors && (this.clientCtrl.errors.inValidModel || this.clientCtrl.errors.required));
            if (this.salesbillentrydata['transaction_type'] == 'Exchange' || this.salesbillentrydata['transaction_type'] == 'Replacement') {
                validation = false;
            }
            return validation
                || (this.transTypeCtrl.errors && (this.transTypeCtrl.errors.required || this.transTypeCtrl.errors.inValidType))
                || (this.salesRetBillCtrl.errors && (this.salesRetBillCtrl.errors.inValidHaModel || this.salesRetBillCtrl.errors.required))
                || this.mode == 'View';
        } else if (this.salesbillentrydata['tabParams'] == 'Sales Bill' && this.salesbillentrydata['client_id'] != undefined) {
            return (this.transTypeCtrl.errors && (this.transTypeCtrl.errors.required || this.transTypeCtrl.errors.inValidType))
                || (this.machineTypeCtrl.errors && (this.machineTypeCtrl.errors.required || this.machineTypeCtrl.errors.invalidType))
                || this.mode == 'View';
        } else {
            return (this.clientCtrl.errors && (this.clientCtrl.errors.inValidModel || this.clientCtrl.errors.required))
                || (this.transTypeCtrl.errors && (this.transTypeCtrl.errors.required || this.transTypeCtrl.errors.inValidType))
                || (this.machineTypeCtrl.errors && (this.machineTypeCtrl.errors.required || this.machineTypeCtrl.errors.invalidType))
                // || (this.warrantyPeriodCtrl.errors && (this.warrantyPeriodCtrl.errors.required || this.warrantyPeriodCtrl.errors.invalidType))
                || this.mode == 'View';
        }
    }

    ///HV SOA SCREEN
    searchEmployee(query: string) {

        this.searchTermsEmp.next(query);
    }
    onSelectedHVClient(clientID: number, empid) {
        if (this._params['page_from'] != 'HV Appointment' && this._params['page_from'] != 'SOA Appointment' && this._params['page_from'] != 'Client Walk-in' && this.advCheck == true) {
            this.onSelectedClient(clientID);
        }
        this.advCheck = true;
        // if(_.isEmpty(clientID)){
        //     clientID = this.salesbillentrydata['client_id'];
        // }
        let that = this,
            //clientID = clientID,
            emp_id = that.salesbillentrydata['empid'] ? that.salesbillentrydata['empid'] : 0;
        if (that.salesbillentrydata['return_id'] && that.salesbillentrydata['return_id'] > 0) {
            emp_id = empid;
        }
        if (that.salesbillentrydata['page_from'] == 'HV Appointment' || that.salesbillentrydata['page_from'] == 'SOA Appointment') {
            emp_id = empid;
        }
        //   hclhvlist = _.find(this.clientHVList, { 'client_id': clientID });
        // if (!_.isEmpty(hclhvlist)) {
        //     this.salesbillentrydata['client_name'] = hclhvlist.client_name;
        // }
        let data = {
            empid: emp_id
            //client_id: clientID
        };
        this.salesBillentryService
            .getChalloutModel(data)
            .then(function (res: any) {
                if (res.success) {

                    if (that.salesBillgriddata['free_item'] == 'Yes') {
                        const filteredHaStockSpare = res['haStockModel'].filter(item => item.from_page === 'Spare' || item.is_charger === 1);
                        that.haList = filteredHaStockSpare;
                        that.halistCtrl.setValue(that.salesBillgriddata['model_id']);
                        that.acthaList = filteredHaStockSpare;
                        const filteredHaStockModel = res['haModelStockSerial'].filter(item => item.from_page === 'Spare' || item.is_charger === 1);
                        that.serialNoList = filteredHaStockModel;
                        that.actSerialNoList = filteredHaStockModel;
                        that.serialNoCtrl.setValue(that.salesBillgriddata['model_id']);
                    }

                    // console.log(filteredHaStockModel);
                    if (that.salesBillgriddata['free_item'] == 'No') {
                        const filteredHaStockModel = res['haModelStockSerial'].filter(item => item.from_page === 'HA Model');
                        that.serialNoList = filteredHaStockModel;
                        that.actSerialNoList = filteredHaStockModel;
                        that.serialNoCtrl.setValue(that.salesBillgriddata['model_id']);
                        const filteredHaStockSpare = res['haStockModel'].filter(item => item.from_page === 'HA Model');
                        that.haList = filteredHaStockSpare;
                        that.halistCtrl.setValue(that.salesBillgriddata['model_id']);
                        that.acthaList = filteredHaStockSpare;
                    }

                    // that.halistCtrl.setValue(that.salesBillgriddata['model_id']);
                }
            });
    }
    onSelectedEmp(mdCompEvent: any) {
        let that = this,
            empid = mdCompEvent.empid,
            data = {
                empid: empid
            };
        that.salesbillentrydata['empid'] = empid;

        this.salesBillentryService
            .getExistChalloutClient(data)
            .then(function (res: any) {
                that.clientHVList = res.data;
            });
    }
    displayEmp(empID: number) {
        if (empID && this.empList.length > 0) {
            let femp = _.find(this.empList, { 'empid': empID });
            this.salesbillentrydata['emp_name'] = femp.empname;

            return femp['empname'];
        }
        else if (empID) {
            return empID
        }
        else {

            return '';
        }

    }
    //HV SOA SCREEN
    loadChallanHaList() {
        let that = this,
            data = {
                stock_type: 'HA MODEL',
                from_page: this._params['tabParams']
            };
        this.commonService
            .getHaModelStock(data)
            .then(function (res: any) {
                if (that._params['tabParams'] == 'Advance') {
                    that.haList = res['haStockModel'];
                }
                if (that._params['tabParams'] == 'Spare Bill') {


                    // const uniqueArray = res['haStockModel'].filter((value, index, self) =>
                    //     index === self.findIndex((t) => (
                    //       t.model_id === value.model_id // Comparing the `id` field
                    //     ))
                    //   );

                    // // that.haList = filteredHaStockSpare;
                    // that.haList = uniqueArray;
                    // that.haList = res['haStockModel'].filter(item => item.from_page === 'Spare');

                    that.haList = res['haStockModel'];
                    that.halistCtrl.setValue(that.salesBillgriddata['model_id']);


                    if (that.salesBillgriddata['free_item'] == 'No') {
                        const filteredHaStockSpare = res['haStockModel'].filter(item => item.from_page === 'Spare' || item.is_charger === 1);

                        const uniqueArray = filteredHaStockSpare.filter((value, index, self) =>
                            index === self.findIndex((t) => (
                                t.model_id === value.model_id // Comparing the `id` field
                            ))
                        );

                        that.haList = uniqueArray;
                        that.halistCtrl.setValue(that.salesBillgriddata['model_id']);
                        that.acthaList = filteredHaStockSpare;
                    }
                }

                if (that._params['tabParams'] != 'Sales Bill' && that._params['tabParams'] != 'HV' && that._params['tabParams'] != 'SOA') {
                    that.acthaList = res['haStockModel'];
                    that.serialNoList = res['haModelStockSerial'];
                    that.actSerialNoList = res['haModelStockSerial'];
                    // that.halistCtrl.setValue(that.salesBillgriddata['model_id']);
                    that.serialNoCtrl.setValue(that.salesBillgriddata['model_id']);
                }


                if (that._params['tabParams'] == 'Sales Bill' || that._params['tabParams'] == 'EMI') {
                    if (that.salesBillgriddata['free_item'] == 'Yes') {
                        that.salesBillgriddata['model_id'] = '';
                        that.salesBillgriddata['serial_no'] = '';
                        // console.log("400 records",res['haStockModel'].length);

                        const filteredHaStockSpare = res['haStockModel'].filter(item => item.from_page === 'Spare' || item.is_charger === 1);

                        const uniqueArray = filteredHaStockSpare.filter((value, index, self) =>
                            index === self.findIndex((t) => (
                                t.model_id === value.model_id // Comparing the `id` field
                            ))
                        );

                        // that.haList = filteredHaStockSpare;
                        that.haList = uniqueArray;
                        // that.haList = [];
                        // console.log("filteredHaStockSpare", filteredHaStockSpare)
                        that.halistCtrl.setValue(that.salesBillgriddata['model_id']);
                        that.acthaList = filteredHaStockSpare;



                        const filteredHaStockModel = res['haModelStockSerial'].filter(item => item.from_page === 'Spare' || item.is_charger === 1);

                        // const uniqueSerialArray = filteredHaStockModel.filter((value, index, self) =>
                        //     index === self.findIndex((t) => (
                        //       t.model_id === value.model_id // Comparing the `id` field
                        //     ))
                        //   );
                        that.serialNoList = filteredHaStockModel;
                        that.actSerialNoList = filteredHaStockModel;

                        // that.serialNoList = filteredHaStockModel;
                        // that.actSerialNoList = filteredHaStockModel;

                        that.serialNoCtrl.setValue(that.salesBillgriddata['serial_no']);
                        if (that._params['tabParams'] == 'EMI') {
                            that.haList = filteredHaStockSpare;
                            that.serialNoList = filteredHaStockModel;
                            that.halistCtrl.setValue(that.salesBillgriddata['serial_no']);
                        }
                    }

                    if (that.salesBillgriddata['free_item'] == 'No' || that._params['tabParams'] == 'EMI') {
                        that.salesBillgriddata['model_id'] = '';
                        that.salesBillgriddata['serial_no'] = '';

                        const filteredHaStockModel = res['haModelStockSerial'].filter(item => item.from_page === 'HA Model');
                        that.serialNoList = filteredHaStockModel;
                        that.actSerialNoList = filteredHaStockModel;
                        that.serialNoCtrl.setValue(that.salesBillgriddata['serial_no']);

                        const filteredHaStockSpare = res['haStockModel'].filter(item => item.from_page === 'HA Model');
                        that.haList = filteredHaStockSpare;
                        that.halistCtrl.setValue(that.salesBillgriddata['model_id']);
                        that.acthaList = filteredHaStockSpare;

                        if (that._params['tabParams'] == 'EMI') {
                            that.haList = filteredHaStockSpare;
                            that.serialNoList = filteredHaStockModel;
                            that.halistCtrl.setValue(that.salesBillgriddata['model_id']);
                        }
                    }
                }


            });
    }


    // onSelectedType(typeName) {

    //     this.haList = [];
    //     this.haList = _.filter(this.actModelList, { 'from_page': typeName });
    //     this.modelCtrl.setValue(this.purchaseInvoice['model_id']);
    // }

    //BRAND MODEL
    filterBrandModel(name: string) {
        name = _.escapeRegExp(name);
        return this.brandModelList$.filter(item => (new RegExp(name, 'gi').test(item.disp_name)));
    }
    displayBrandModelFn(modelID: number) {
        if (modelID && this.brandModelList$.length > 0) {
            let fitem = _.find(this.brandModelList$, { 'model_id': modelID });
            this.salesBillgriddata['brand_model_name'] = fitem['disp_name'];
            return fitem['disp_name'];
        }
        return '';
    }
    //BRAND
    filterBrand(name: string) {
        name = _.escapeRegExp(name);
        return this.brandList$.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }
    displayBrandFn(brandID: number) {
        if (brandID && this.brandList$.length > 0) {
            let fitem = _.find(this.brandList$, { 'brand_id': brandID });
            this.salesBillgriddata['brand_name'] = fitem['name'];
            return fitem['name'];
        }
        return '';
    }
    //FAMILY
    filterFamily(name: string) {
        name = _.escapeRegExp(name);
        return this.familyList$.filter(item => (new RegExp(name, 'gi').test(item.family_name)));
    }
    displayFamilyFn(familyID: number) {
        if (familyID && this.familyList$.length > 0) {
            let fitem = _.find(this.familyList$, { 'family_id': familyID });
            this.salesBillgriddata['family_name'] = fitem['family_name'];
            return fitem['family_name'];
        }
        return '';
    }

    onChangeFamily() {
        this.loadFamilyList();
        this.loadAllList();
    }

    onChangeModel() {
        //TO LOAD MODEL STOCK LIST
        this.loadChallanHaList();
        console.log("halist", this.haList);
    }

    //Series
    filterSeries(name: string) {
        name = _.escapeRegExp(name);
        return this.seriesList$.filter(item => (new RegExp(name, 'gi').test(item.series_name)));
    }
    displaySeriesFn(seriesID: number) {
        if (seriesID && this.seriesList$.length > 0) {
            let seriesitem = _.find(this.seriesList$, { 'series_id': seriesID });
            this.salesBillgriddata['series_name'] = seriesitem['series_name'];
            return seriesitem['series_name'];
        }
        return '';
    }

    //Performance
    filterPerformance(name: string) {
        name = _.escapeRegExp(name);
        return this.performanceList$.filter(item => (new RegExp(name, 'gi').test(item.performance_name)));
    }
    displayPerformanceFn(performanceID: number) {
        if (performanceID && this.performanceList$.length > 0) {
            let performanceitem = _.find(this.performanceList$, { 'performance_id': performanceID });
            this.salesBillgriddata['performance_name'] = performanceitem['performance_name'];
            return performanceitem['performance_name'];
        }
        return '';
    }

    //Power
    filterPower(name: string) {
        name = _.escapeRegExp(name);
        return this.powerList$.filter(item => (new RegExp(name, 'gi').test(item.power_name)));
    }
    displayPowerFn(powerID: number) {
        if (powerID && this.powerList$.length > 0) {
            let poweritem = _.find(this.powerList$, { 'power_id': powerID });
            this.salesBillgriddata['power_name'] = poweritem['power_name'];
            return poweritem['power_name'];
        }
        return '';
    }

    //Battery
    filterBattery(name: string) {
        name = _.escapeRegExp(name);
        return this.batteryList$.filter(item => (new RegExp(name, 'gi').test(item.battery_name)));
    }
    displayBatteryFn(batteryID: number) {
        if (batteryID && this.batteryList$.length > 0) {
            let batteryitem = _.find(this.batteryList$, { 'battery_id': batteryID });
            this.salesBillgriddata['battery_name'] = batteryitem['battery_name'];
            return batteryitem['battery_name'];
        }
        return '';
    }

    loadAllList() {
        let that = this;
        //to get series list
        this.commonService
            .getAllList()
            .then(function (res: any) {
                const seriesdata = res.data.filter(item => item.brand_id === that.salesBillgriddata['brand_id']);
                that.seriesList$ = seriesdata;
                that.seriesCtrl.setValue(that.salesBillgriddata['series_id']);

                const powerdata = res.powerdata.filter(item => item.brand_id === that.salesBillgriddata['brand_id']);
                that.powerList$ = powerdata;
                that.powerCtrl.setValue(that.salesBillgriddata['power_id']);

                const performancedata = res.performancedata.filter(item => item.brand_id === that.salesBillgriddata['brand_id']);
                that.performanceList$ = performancedata;
                that.performanceCtrl.setValue(that.salesBillgriddata['performance_id']);

                // const batterydata = res.batterydata.filter(item => item.brand_id === that.salesBillgriddata['brand_id']);
                that.batteryList$ = res.batterydata;
                that.batteryCtrl.setValue(that.salesBillgriddata['battery_id']);

            });
    }

    onChangeFreeType() {
        this.advCheck = false;
        if (this.salesbillentrydata['tabParams'] != 'HV' && this.salesbillentrydata['tabParams'] != 'SOA') {
            this.loadChallanHaList();
            this.salesBillgriddata['model_id'] = "";
            this.salesBillgriddata['serial_no'] = "";
        } else {
            this.salesBillgriddata['model_id'] = "";
            this.salesBillgriddata['serial_no'] = "";
            this.salesBillgriddata['name'] = "",
                this.salesBillgriddata['mrp'] = "",
                this.salesBillgriddata['rate'] = "",
                this.salesBillgriddata['quantity'] = "",
                this.salesBillgriddata['amount'] = "",
                this.salesBillgriddata['challan_out_id'] = "",
                this.salesBillgriddata['tax_per'] = "",
                this.salesBillgriddata['ha_model_branch'] = "",
                this.salesBillgriddata['serialno_branch'] = "",
                this.salesBillgriddata['challan_no'] = "",
                this.salesBillgriddata['series_name'] = "",
                this.salesBillgriddata['performance_name'] = "",
                this.salesBillgriddata['family_name'] = "",
                this.salesBillgriddata['battery_name'] = "",
                this.salesBillgriddata['tele_audiology'] = "",
                this.onSelectedHVClient(this.salesbillentrydata['client_id'], this.salesbillentrydata['empid']);
        }
    }

    filterHa(name: string) {
        name = _.escapeRegExp(name);
        return this.haList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name)));
    }

    filterSpareAndCharger(model_id: string) {

        console.log(model_id, ' ha model')
        // name = _.escapeRegExp(name);
        console.log('after', name);



        // console.log(this.haList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name))));
        console.log(this.haList.filter(ha => ha.model_id == model_id))


        return this.haList.filter(ha => ha.model_id == model_id);
    }

    // filterHsn(name: string) {
    //     name = _.escapeRegExp(name);
    //     return this.hsnList.filter(ha => (new RegExp(name, 'gi').test(ha.hsn_id) || new RegExp(name, 'gi').test(ha.hsn_code)));
    // }

    // displayHsn(hsn_id: any) {
    //     if (this.hsnList != undefined) {
    //         if (hsn_id && this.hsnList.length > 0) {
    //             let fitem = _.find(this.hsnList, { 'hsn_id': hsn_id });
    //             this.salesBillgriddata['hsn_name'] = fitem.hsn_code;
    //             return fitem['hsn_code'];
    //         }
    //     }
    //     return '';
    // }

    displayHaSpare(model_id: number) {

        if (model_id && this.haList.length > 0 && ((this.salesBillgriddata['free_item'] == 'No' && this._params['tabParams'] == 'Spare Bill') || (this.salesBillgriddata['free_item'] == 'Yes' && (this._params['tabParams'] == 'Sales Bill' || this._params['tabParams'] == 'EMI' || this._params['tabParams'] == 'HV' || this._params['tabParams'] == 'SOA')))) {
            this.serialNoList = [];
            let fhalist = _.find(this.haList, { 'model_id': model_id['model_id'] });
            // Load all serial numbers for the selected model (same logic for all tabs)
            this.getModelSerialNo(model_id['model_id']);

            // Clear serial number field to allow user to select from all available options

            if (this._params['tabParams'] != 'HV' && this._params['tabParams'] != 'SOA') {
                this.displaySerialNoSpr(fhalist);
            }

            return fhalist['name'];
        }
        return '';
    }

    getModelSerialNo(modelID) {
        let actSerialNoList = this.actSerialNoList;
        this.serialNoList = _.filter(actSerialNoList, { 'model_id': modelID });
        this.serialNoCtrl.setValue(this.salesBillgriddata['model_id']);
    }

    displaySerialNoSpr(serial_no) {
        if (typeof serial_no != 'string' || this._params['tabParams'] == 'Advance') {
            if (serial_no && this.serialNoList.length > 0) {
                // let fhalist = _.find(this.serialNoList, { 'serial_no': serial_no.serial_no, 'branch' : serial_no.branch }),   rate = 0,
                //     mrp = fhalist.model_mrp;
                let fhalist;
                if (this.salesbillentrydata['tabParams'] == 'HV' || this.salesbillentrydata['tabParams'] == 'SOA') {
                    fhalist = this.serialNoList.find((el) => el.serial_no == serial_no.serial_no && el.branch == serial_no.branch && el.challan_no == serial_no.challan_no);
                } else {
                    fhalist = this.serialNoList.find((el) => el.serial_no == serial_no.serial_no && el.branch == serial_no.branch);
                }

                if (fhalist) {
                    let rate = 0,
                        mrp = fhalist.model_mrp;

                    if (parseFloat(fhalist.mrp) < parseFloat(fhalist.model_mrp)) {
                        mrp = fhalist.mrp;
                    }
                    this.salesBillgriddata['mrp'] = mrp;
                    this.salesBillgriddata['challan_out_id'] = fhalist.challan_out_id;
                    //if(this._params['tabParams'] !== 'Advance') {
                    this.salesBillgriddata['serial_no'] = fhalist.serial_no;
                    this.salesBillgriddata['name'] = fhalist.name;
                    this.salesBillgriddata['ha_model_from_page'] = fhalist.from_page;
                    this.salesbillentrydata['ha_model_from_page'] = fhalist.from_page;
                    this.salesBillgriddata['stock_type'] = fhalist.stock_type;
                    this.salesBillgriddata['ha_model_branch'] = fhalist.branch;
                    this.salesbillentrydata['warranty_type'] = fhalist.warranty_type;
                    this.salesBillgriddata['warranty_type'] = fhalist.warranty_type;
                    this.salesBillgriddata['serialno_branch'] = fhalist.branch_disp_name ? fhalist.branch_disp_name : '';
                    this.salesBillgriddata['challan_no'] = fhalist.challan_no ? fhalist.challan_no : '';
                    //}
                    this.salesBillgriddata['tax_per'] = fhalist.tax_per;
                    this.salesBillgriddata['quantity'] = 1;

                    /* if (parseFloat(fhalist.tax_per) > 0) {
                         rate = parseFloat(mrp)*100/(100-  parseFloat(fhalist.tax_per));
                     } else {
                         rate = parseFloat(mrp);
                     }*/
                    if (!_.isEmpty(_.toString(fhalist.tax_per))) {
                        rate = ((mrp) * (parseFloat(fhalist.tax_per)) / (100)) + (mrp);
                    }
                    rate = Math.round(rate);
                    //rate = Math.round(rate);
                    this.salesBillgriddata['rate'] = rate;
                    this.calAmount();

                    return fhalist['serial_no'];
                } else {
                    return '';
                }

            } else {
                return '';
            }
        }
        return serial_no;

    }


    displayHa(model_id) {
        // this.haList = [];
        // if (model_id && this.haList.length > 0) {
        //     let fhalist = _.find(this.haList, { 'model_id': model_id });
        //     if (fhalist['stock_type'] == 'Spare' || this._params['tabParams'] == 'Advance') {
        //         this.serialNoList.push(fhalist);
        //         this.displaySerialNo(fhalist);
        //     } else {
        //         this.getModelSerialNo(model_id); //TO LOAD SERIAL NUMBER FOR THAT MODEL
        //     }
        //     return fhalist['name'];
        // }
        // return '';

        if (typeof model_id != 'string') {
            if (model_id && this.haList.length > 0) {
                // let fhalist = _.find(this.serialNoList, { 'serial_no': serial_no.serial_no, 'branch' : serial_no.branch }),   rate = 0,
                //     mrp = fhalist.model_mrp;
                let fhalist;
                // For Advance billing, serial number is not required, so find by model_id only
                if (this.salesbillentrydata['tabParams'] == 'Advance') {
                    fhalist = this.haList.find((el) => el.model_id == model_id.model_id);
                } else if (this.salesbillentrydata['tabParams'] == 'HV' || this.salesbillentrydata['tabParams'] == 'SOA') {
                    // For HV/SOA, match by model_id, branch, challan_no, and serial_no from the selected model object itself
                    fhalist = this.haList.find((el) => el.model_id == model_id.model_id && el.branch == model_id.branch && el.challan_no == model_id.challan_no && el.serial_no == model_id.serial_no);
                } else {
                    fhalist = this.haList.find((el) => el.model_id == model_id.model_id && el.branch == model_id.branch && el.serial_no == this.salesBillgriddata['serial_no']);
                }

                if (fhalist) {
                    let rate = 0,
                        mrp = fhalist.model_mrp;

                    if (parseFloat(fhalist.mrp) < parseFloat(fhalist.model_mrp)) {
                        mrp = fhalist.mrp;
                    }

                    this.salesBillgriddata['mrp'] = mrp;
                    this.salesBillgriddata['challan_out_id'] = fhalist.challan_out_id;
                    //if(this._params['tabParams'] !== 'Advance') {
                    this.salesBillgriddata['model_id'] = fhalist.name;
                    this.salesBillgriddata['name'] = fhalist.name;
                    this.salesBillgriddata['ha_model_from_page'] = fhalist.from_page;
                    this.salesbillentrydata['ha_model_from_page'] = fhalist.from_page;
                    this.salesBillgriddata['stock_type'] = fhalist.stock_type;
                    this.salesBillgriddata['ha_model_branch'] = model_id.branch;
                    this.salesbillentrydata['warranty_type'] = fhalist.warranty_type;
                    this.salesBillgriddata['warranty_type'] = fhalist.warranty_type;
                    if (this._params['tabParams'] == 'Sales Bill' || this._params['tabParams'] == 'Advance' || this._params['tabParams'] == 'HV' || this._params['tabParams'] == 'SOA' || this._params['tabParams'] == 'EMI') {
                        this.salesBillgriddata['brand_name'] = fhalist.brand_name;
                        this.salesBillgriddata['brand_model_name'] = fhalist.brand_model_name;
                        this.salesBillgriddata['family_name'] = fhalist.family_name;
                        this.salesBillgriddata['series_name'] = fhalist.series_name;
                        this.salesBillgriddata['performance_name'] = fhalist.performance_name;
                        this.salesBillgriddata['power_name'] = fhalist.power_name;
                        this.salesBillgriddata['battery_name'] = fhalist.battery_name;
                        this.salesBillgriddata['color_name'] = fhalist.color_name;
                        this.salesBillgriddata['tele_audiology'] = fhalist.tele_audiology;
                        this.salesBillgriddata['brand_id'] = fhalist.brand_id;
                        this.salesBillgriddata['brand_model_id'] = fhalist.brand_model_id;
                        this.salesBillgriddata['family_id'] = fhalist.family_id;
                        this.salesBillgriddata['series_id'] = fhalist.series_id;
                        this.salesBillgriddata['performance_id'] = fhalist.performance_id;
                        this.salesBillgriddata['power_id'] = fhalist.power_id;
                        this.salesBillgriddata['battery_id'] = fhalist.battery_id;
                        this.salesBillgriddata['color_id'] = fhalist.color_id;
                    }
                    //hv soa needed
                    if (this._params['tabParams'] != 'Advance') {
                        this.salesBillgriddata['serialno_branch'] = this.actSerialNoList[0].branch_disp_name ? this.actSerialNoList[0].branch_disp_name : '';
                        this.salesBillgriddata['challan_no'] = this.actSerialNoList[0].challan_no ? this.actSerialNoList[0].challan_no : '';
                    }
                    //}
                    this.salesBillgriddata['tax_per'] = fhalist.tax_per;
                    this.salesBillgriddata['quantity'] = 1;

                    /* if (parseFloat(fhalist.tax_per) > 0) {
                         rate = parseFloat(mrp)*100/(100-  parseFloat(fhalist.tax_per));
                     } else {
                         rate = parseFloat(mrp);
                     }*/
                    if (!_.isEmpty(_.toString(fhalist.tax_per))) {
                        rate = ((mrp) * (parseFloat(fhalist.tax_per)) / (100)) + (mrp);
                    }
                    rate = Math.round(rate);
                    //rate = Math.round(rate);
                    this.salesBillgriddata['rate'] = rate;
                    this.calAmount();

                    return fhalist['name'];
                } else {
                    return '';
                }

            } else {
                return '';
            }
        }
        return '';
    }

    filterSalesRetBill(name: string) {
        name = _.escapeRegExp(name);
        return this.salesReturnList.filter(obj => (new RegExp(name, 'gi').test(obj.dispName)));
    }

    displaySalesRetBillNo(return_id: number) {
        if (return_id && this.salesReturnList.length > 0) {
            const returnObj = _.find(this.salesReturnList, { 'return_id': return_id });
            if (returnObj) {
                this.salesbillentrydata['return_bill_amt'] = returnObj.return_amount;
                this.calGrossTotal();
                return returnObj['dispName'];
            }
        }
        this.salesbillentrydata['return_bill_amt'] = 0;
        return '';
    }

    getModelNo(modelID) {
        let acthaList = this.acthaList;

        // Check if acthaList contains model objects or serial number objects
        if (acthaList.length > 0 && acthaList[0].hasOwnProperty('serial_no')) {
            // For HV/SOA, we want to use the SELECTED serial number's data
            // actSerialNoList contains the serial number that was just selected
            if (this.actSerialNoList.length > 0 && this.actSerialNoList[0].model_id === modelID) {
                this.haList = [this.actSerialNoList[0]];
            } else {
                // Fallback: Filter serial numbers by model_id
                const filteredSerials = acthaList.filter(item => item.model_id === modelID);
                this.haList = filteredSerials.length > 0 ? [filteredSerials[0]] : [];
            }
        } else {
            this.haList = _.filter(acthaList, { 'model_id': modelID });
        }

        // Set the first model if available
        if (this.haList.length > 0) {
            this.halistCtrl.setValue(this.haList[0]);
        }
        // Don't auto-set the value, let user select from filtered list
    }
    filterSerialNo(name: string) {
        name = _.escapeRegExp(name);
        // return this.actSerialNoList.filter(ha => (new RegExp(name, 'gi').test(ha.serial_no)));

        return this.serialNoList.filter(ha => (new RegExp(name, 'gi').test(ha.serial_no)));
    }

    displaySerialNo(serial_no) {
        if (serial_no && this.serialNoList.length > 0 && this.salesBillgriddata['free_item'] == 'No') {
            this.haList = [];
            this.actSerialNoList = [];
            if (this._params['tabParams'] == 'HV' || this._params['tabParams'] == 'SOA') {
                let fseriallist = _.find(this.serialNoList, serial_no);
                this.actSerialNoList.push(fseriallist);

                this.getModelNo(fseriallist['model_id']); //TO LOAD SERIAL NUMBER FOR THAT MODEL

                return fseriallist['serial_no'];
            }
            else {
                let fseriallist = _.find(this.serialNoList, { 'serial_no': serial_no });
                this.actSerialNoList.push(fseriallist);
                // if (fseriallist['stock_type'] == 'Spare' || this._params['tabParams'] == 'Advance') {
                //     this.haList.push(fseriallist);
                //     // this.haList = fseriallist;
                //     this.displayHa(fseriallist);
                // } else {
                this.getModelNo(fseriallist['model_id']); //TO LOAD SERIAL NUMBER FOR THAT MODEL
                // }
                return fseriallist['serial_no'];
            }

        }
        return '';

    }

    onSelectedHaList(mdCompEvent: any) {
        let model_id = mdCompEvent.option.value,
            fhalist = _.find(this.haList, { 'model_id': model_id });

        this.salesBillgriddata['name'] = fhalist.name;
    }

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: this.salesbillentrydata['tabParams'],
                date: moment(this.salesbillentrydata['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function (res: any) {
                if (res['success']) {
                    that.salesbillentrydata['auto_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    searchClient(query: string) {
        this.searchTerms.next(query);
    }

    setPageData(): void {
        if (this._params != undefined) {
            let mode = this._params['mode'];

            //Branch select contrl only for Admin and Coordinator
            this.salesbillentrydata['user_role_type'] = this._params['user_role_type'];
            // if (this.salesbillentrydata['user_role_type'] != 'COORDINATOR' && this.salesbillentrydata['user_role_type'] != 'COORDINATOR AND CAN_EDIT_ACCOUNTS') {
            //     this.branchCtrl.disable();
            // }
            this.salesbillentrydata = Object.assign({}, this._params);

            if (this._params['walikin_date']) {
                var fechaLatinFormat = this._params['walikin_date'];
                var datePieces = fechaLatinFormat.split("-");
                var preFinalDate = new Date(parseInt(datePieces[2]), parseInt(datePieces[1]) - 1, parseInt(datePieces[0]));
                this.salesbillentrydata['date'] = preFinalDate;
            }
            else if (this._params['disp_date']) {
                var fechaLatinFormat = this._params['disp_date'];
                var datePieces = fechaLatinFormat.split("-");
                var preFinalDate = new Date(parseInt(datePieces[2]), parseInt(datePieces[1]) - 1, parseInt(datePieces[0]));
                this.salesbillentrydata['date'] = preFinalDate;
                // this.salesbillentrydata['date'] = new Date(this._params['disp_date']);
            }
            else {
                this.salesbillentrydata['date'] = new Date(this._params['date']);
                this.salesbillentrydata['usertype'] = this._params['user_role_type'];
                this.salesbillentrydata['branch'] = this._params['branchName'];
            }

            if (mode == 'Edit') {
                this.mode = mode;
                this.branchCtrl.disable();
                this.getSalesbillentryDetailList();
                this.salesbillentrydata['bank'] = this._params['bank'];
                // this.salesbillentrydata['date'] = new Date(this._params['date']);//new Date();

                // if(this._params['walikin_date']){
                //     var fechaLatinFormat= this._params['walikin_date'];
                //     var datePieces = fechaLatinFormat.split("-"); 
                //     var preFinalDate = new Date(parseInt(datePieces[2]), parseInt(datePieces[1]) - 1, parseInt(datePieces[0]));    
                //     this.salesbillentrydata['date'] = preFinalDate;
                // }
                // else if(this._params['disp_date']){
                //     var fechaLatinFormat= this._params['disp_date'];
                //     var datePieces = fechaLatinFormat.split("-"); 
                //     var preFinalDate = new Date(parseInt(datePieces[2]), parseInt(datePieces[1]) - 1, parseInt(datePieces[0]));    
                //     this.salesbillentrydata['date'] = preFinalDate;
                //     // this.salesbillentrydata['date'] = new Date(this._params['disp_date']);
                // }
                // else{
                //     this.salesbillentrydata['date'] = new Date(this._params['date']);
                // }
                if (this._params['type'] && typeof this._params['type'] === 'string') {
                    this.salesbillentrydata['type'] = this._params['type'].split('&').map(t => t.trim());
                } else if (Array.isArray(this._params['type'])) {
                    this.salesbillentrydata['type'] = this._params['type'];
                } else {
                    this.salesbillentrydata['type'] = [];
                }
                this.salesbillentrydata['hidden_client'] = this._params['client_no']; // FOR AUTO COMPLETE ALTERNATE
                this.salesBillgriddata['cash_amt'] = this._params['cash_amt'];
                this.salesbillentrydata['warranty_type'] = this._params['warranty_period'];
                this.salesBillgriddata['card_amt'] = this._params['card_amt'];
                this.salesBillgriddata['credit_amt'] = this._params['credit_amt'];
                this.salesBillgriddata['online_amt'] = this._params['online_amt'];
                this.salesBillgriddata['cheque_amt'] = this._params['cheque_amt'];
                this.salesBillgriddata['chqno'] = this._params['chqno'];
                this.salesBillgriddata['onlineno'] = this._params['onlineno'];
                this.salesBillgriddata['payment_type'] = this._params['payment_type'];
                if (this._params['tabParams'] == 'HV' || this._params['tabParams'] == 'SOA') {
                    this.salesbillentrydata['prev_transaction_type'] = this._params['transaction_type'];
                    this.onSelectedHVClient(this._params['client_id'], 0);
                }

                // Load redeem & coupon discount fields
                this.salesbillentrydata['redeem_discount'] = parseFloat(this._params['redeem_discount']) || 0;
                this.salesbillentrydata['coupon_discount'] = parseFloat(this._params['coupon_discount']) || 0;
                this.couponCodeInput = this._params['coupon_code'] || '';
                if (this.salesbillentrydata['coupon_discount'] > 0) {
                    this.salesbillentrydata['coupon_opted'] = true;
                    this.couponOtpVerified = true;
                }
                this.calGrantTotal('all');

                this.onChangeBillType();
            } else if (mode == 'View') {
                this.mode = mode;
                this.getSalesbillentryDetailList();
                // this.salesbillentrydata['date'] = new Date(this._params['date']);//new Date();
                if (this._params['type'] && typeof this._params['type'] === 'string') {
                    this.salesbillentrydata['type'] = this._params['type'].split('&').map(t => t.trim());
                } else if (Array.isArray(this._params['type'])) {
                    this.salesbillentrydata['type'] = this._params['type'];
                } else {
                    this.salesbillentrydata['type'] = [];
                }
                this.salesbillentrydata['hidden_client'] = this._params['client_no']; // FOR AUTO COMPLETE ALTERNATE
                this.salesBillgriddata['cash_amt'] = this._params['cash_amt'];
                this.salesbillentrydata['warranty_type'] = this._params['warranty_period'];
                this.salesBillgriddata['card_amt'] = this._params['card_amt'];
                this.salesBillgriddata['credit_amt'] = this._params['credit_amt'];
                this.salesBillgriddata['online_amt'] = this._params['online_amt'];
                this.salesBillgriddata['cheque_amt'] = this._params['cheque_amt'];
                this.salesBillgriddata['chqno'] = this._params['chqno'];
                this.salesBillgriddata['onlineno'] = this._params['onlineno'];
                this.salesBillgriddata['payment_type'] = this._params['payment_type'];
                this.salesbillentrydata['empid'] = this._params['empname'];
                if (this._params['tabParams'] == 'HV' || this._params['tabParams'] == 'SOA') {
                    this.onSelectedHVClient(this._params['client_id'], 0);
                }

                // Load redeem & coupon discount fields
                this.salesbillentrydata['redeem_discount'] = parseFloat(this._params['redeem_discount']) || 0;
                this.salesbillentrydata['coupon_discount'] = parseFloat(this._params['coupon_discount']) || 0;
                this.couponCodeInput = this._params['coupon_code'] || '';
                if (this.salesbillentrydata['coupon_discount'] > 0) {
                    this.salesbillentrydata['coupon_opted'] = true;
                    this.couponOtpVerified = true;
                }
                this.calGrantTotal('all');

            } else if (mode == 'HvConvertToNormal') {
                this.transTypeCtrl.disable();
                // this.salesbillentrydata['date'] = new Date(this._params['date']);//new Date();
                this.salesbillentrydata['hidden_client'] = this._params['client_no']; // FOR AUTO COMPLETE ALTERNATE
                this.salesBillgriddata['cash_amt'] = this._params['cash_amt'];
                this.salesBillgriddata['empid'] = this._params['empid'];
                this.salesBillgriddata['client_id'] = this._params['client_id'];
                this.salesBillgriddata['card_amt'] = this._params['card_amt'];
                this.salesBillgriddata['credit_amt'] = this._params['credit_amt'];
                this.salesBillgriddata['online_amt'] = this._params['online_amt'];
                this.salesBillgriddata['cheque_amt'] = this._params['cheque_amt'];
                this.salesBillgriddata['chqno'] = this._params['chqno'];
                this.salesBillgriddata['onlineno'] = this._params['onlineno'];
                this.salesBillgriddata['payment_type'] = this._params['payment_type'];
                this.salesBillgriddata['transaction_type'] = this._params['transaction_type'];
                if (this._params['tabParams'] == 'HV' || this._params['tabParams'] == 'SOA') {
                    this.onSelectedHVClient(this._params['client_id'], 0);
                }


                this.mode = "Add";
            }

            // if (mode == 'Add' && this._params['tabParams'] == 'Advance') {
            //     if(this._params['client_no']){
            //         // this.branchCtrl.disable();
            //         this.getSalesbillentryDetailList();
            //         this.salesbillentrydata['bank'] = this._params['bank'];
            //         // this.salesbillentrydata['date'] = new Date(this._params['date']);
            //         this.salesbillentrydata['hidden_client'] = this._params['client_no']; 
            //         this.salesbillentrydata['ref_name'] = this._params['reference_name'];

            //         // this.onChangeBillType();
            //     }
            //     this.loadChallanHaList();

            // }
            if (mode == 'Add') {
                if (this._params['client_no']) {
                    this.salesbillentrydata['hidden_client'] = this._params['client_no'];
                    this.salesbillentrydata['ref_name'] = this._params['reference_name'];

                    if (this._params['page_from'] == 'Client Walk-in') {
                        this.salesbillentrydata['advances'] = '';
                        this.onSelectedClient(this._params['client_id']);
                    }
                    if (this._params['page_from'] == 'HV Entry' || this._params['page_from'] == 'SOA Entry') {
                        this.salesbillentrydata['advances'] = '';
                        this.onSelectedClient(this._params['client_id']);
                        this.advCheck = true;
                    }
                    if (this._params['page_from'] == 'HV Appointment' || this._params['page_from'] == 'SOA Appointment') {
                        this.salesbillentrydata['advances'] = '';
                        this.onSelectedHVClient(this._params['client_id'], 0);
                        this.searchClient(this._params['client_no']);
                        this.onSelectedClient(this._params['client_id']);
                    }
                    else {
                        this.loadChallanHaList();
                    }
                }
                if (this._params['tabParams'] == 'Advance') {
                    // this.getSalesbillentryDetailList();
                    this.salesbillentrydata['bank'] = this._params['bank'];
                }

            }

            if (this._params['tabParams'] == 'HV' || this._params['tabParams'] == 'SOA') {
                this.getTestingtypeList();
            }

            if ((this._params['tabParams'] == 'HV' || this._params['tabParams'] == 'SOA') && this.salesbillentrydata['mode1'] == 'View' && this.salesbillentrydata['mode'] == 'Add') {
                this.branchCtrl.enable();
            }


            this.transTypeCtrl.disable();
            if (mode == 'Add' || ((mode == 'Edit' && this.salesbillentrydata['prev_transaction_type'] == 'Trial') && (this.salesbillentrydata['user_role_type'] == 'CAN_EDIT_ACCOUNTS' || this.salesbillentrydata['user_role_type'] == 'COORDINATOR AND CAN_EDIT_ACCOUNTS'))) {
                this.transTypeCtrl.enable();
            }

            if (this.salesbillentrydata['from_page'] == 'exchange' || this.salesbillentrydata['from_page'] == 'replacement') {
                this.salesbillentrydata['from_type'] = this.salesbillentrydata['return_to'].toUpperCase();
                this.transTypeList = [this.salesbillentrydata['transaction_type']];
                this.transTypeCtrl.disable();
                this.salesRetBillCtrl.disable();
            }
            // if (mode === 'Exchange' || mode === 'Replacement') {
            //     this.salesbillentrydata['transaction_type'] = this._params['return_type'];
            //     this.getSalesbillentryDetailList(); 
            // }

        }
    }

    displayFn(client_id: any) {
        if (this.clientList != undefined) {
            if (client_id && this.clientList.length > 0) {
                let fitem = _.find(this.clientList, { 'client_id': client_id });
                this.salesbillentrydata['client_name'] = fitem.client_name; //ANOTHER FIELD
                this.salesbillentrydata['ref_name'] = fitem.reference_name; //ANOTHER FIELD
                this.salesbillentrydata['reference_name'] = fitem.reference_name; //ANOTHER FIELD

                this.onChangeBillType();
                return fitem['client_no'];
            }
        }
        return '';
    }
    displayHvSoaFn(client_id: any) {
        if (this.clientHVList != undefined) {
            if (client_id && this.clientHVList.length > 0) {
                let fitem = _.find(this.clientHVList, { 'client_id': client_id });
                return fitem['client_no'];
            }
        }
        return '';
    }

    loadSrcList() {
        let that = this,
            data = {
                name: ''
            };
        this.commonService
            .getBankLedger(data)
            .then(function (res: any) {
                that.srcList = res['data'];
                // that.actSerialNoList = res['haModelStockSerial'];
                that.srclistCtrl.setValue(that.salesbillentrydata['bank']);
                //that.srclistCtrl.setValue(that.clientInData['bank_name']);
                //that.emplist2Ctrl.setValue(that.clientFollowDet['empid']);
            });
        // this.commonService.getHsnCodeList().then(function (res: any){
        //     that.hsnList = res['data'];
        //     that.hsnCtrl.setValue(that.salesBillgriddata['hsn_code']);
        // })
    }

    filterSrc(bank_name: string) {
        bank_name = _.escapeRegExp(bank_name);
        return this.srcList.filter(ha => (new RegExp(bank_name, 'gi').test(ha.bank)
            || new RegExp(bank_name, 'gi').test(ha.bank_name)));
    }

    displaySrc(item_id: number) {

        if (item_id && this.srcList.length > 0) {
            let fhalist = _.find(this.srcList, { 'bank': item_id }),
                bank_name = fhalist.bank_name;
            this.salesbillentrydata['bank_name'] = bank_name;
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(item_id);
            return fhalist['bank_name'];
        }
        return '';
    }

    onChangeBillType() {
        if (this.salesbillentrydata['mode'] == 'Add' && this.salesbillentrydata['from_page'] != 'exchange' && this.salesbillentrydata['from_page'] != 'replacement') {
            this.salesbillentrydata['return_bill_amt'] = 0;
            this.salesbillentrydata['given_amount'] = 0;
            this.salesbillentrydata['return_id'] = null;
            this.salesReturnList = [];
        }
        this.calGrantTotal('');
        if (this.salesbillentrydata['client_id'] && (this.salesbillentrydata['transaction_type'] == 'Exchange' || this.salesbillentrydata['transaction_type'] == 'Replacement')) {
            this.salesBillentryService
                .getPendingSalesReturnBills({
                    bill_id: this.salesbillentrydata['bill_id'],
                    client_id: this.salesbillentrydata['client_id']
                })
                .then((res: any) => {
                    if (res.success) {
                        this.salesReturnList = res.data;
                        this.salesRetBillCtrl.setValue(this.salesbillentrydata['return_id']);
                    } else {
                        swal('WARNING', 'Error While loading Return details, Please try again later', 'warning');
                    }
                });
        }
    }

    getSalesbillentryDetailList(): void {
        let that = this;
        let params: any;
        let mode = this._params['mode'];
        let bill_type = this.salesbillentrydata['tabParams'];
        if (mode === 'Exchange' || mode === 'Replacement') {
            params = {
                bill_id: this._params['bill_id'],
                bill_type: this._params['mode'],
                mode: this._params['mode'],
                branch: this._params['branch'],
                date: moment(this._params['date']).format('YYYY-MM-DD')
            };
        } else {
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `${this.page.orderBy}`,
                orderBy: 'bill_id',
                orderDir: `${this.page.orderDir}`,
                bill_id: this.salesbillentrydata['bill_id'],
                client_id: this.salesbillentrydata['client_id'],
                bill_type: bill_type,
                mode: this._params['mode'],
                branch: this._params['branch'],
                date: moment(this._params['date']).format('YYYY-MM-DD')
            };
        }
        this.isLoadMask = this.salesBillentryService
            .getSalesbillentryDetailList(params)
            .then(function (res: any) {
                if (res.success) {
                    that.testTravelRes = res.testTravelRes;
                    if (bill_type == 'Advance') {
                        if (res.old_advance != 0 && mode == 'Edit') {
                            that.subscribeService.subScribeDeleteActiveTab();
                            swal('WARNING', 'Next Advance Entry Found, so you can not Edit this Advance Bill Details', 'warning');
                            return;
                        }
                    }
                    that.page.count = res.totCnt;
                    that.salesBillentryDetails = res.data;
                    if (bill_type == 'Advance' && mode == 'Edit') {
                        that.salesbillentrydata['oldadvances'] = res.old_advance;
                        that.calGrantTotal('all');
                    } else if (bill_type == 'EMI') {
                        that.emiDetails = res.emiDet;
                    }
                    // Load billing header fields for edit/view
                    if ((mode == 'Edit' || mode == 'View') && res.billHeader) {
                        that.salesbillentrydata['redeem_discount'] = parseFloat(res.billHeader.redeem_discount) || 0;
                        that.salesbillentrydata['coupon_discount'] = parseFloat(res.billHeader.coupon_discount) || 0;
                        that.couponCodeInput = res.billHeader.coupon_code || '';
                        if (that.salesbillentrydata['coupon_discount'] > 0) {
                            that.salesbillentrydata['coupon_opted'] = true;
                            that.couponOtpVerified = true;
                        }
                        that.calGrantTotal('all');
                    }
                } if (mode === 'Exchange' || mode === 'Replacement') {
                    // that.filteredHa = res.data;
                    for (let i = 0; i < res.data.length; i++) {
                        that.salesBillgriddata['rate'] = res.data[i].rate;
                        that.salesBillgriddata['model_id'] = res.data[i].details_id;
                        that.salesbillentrydata['auto_no'] = res.data[i].sale_bill_no;
                        that.salesbillentrydata['hidden_client'] = res.data[i].client_no;
                        //that.salesbillentrydata['client_id'] = res.data[i].client_id;
                        that.salesbillentrydata['client_name'] = res.data[i].client_name;
                        that.salesBillgriddata['free_item'] = res.data[i].free_item;
                        that.salesbillentrydata['type'] = res.data[i].mode;
                        that.salesbillentrydata['hidden_return_id'] = res.data[i].return_bill_amt;
                        that.salesbillentrydata['date'] = new Date(res.data[i].date);
                    }
                }
            });
    }

    onSelectedClient(mdCompEvent: any) {
        let that = this,
            data = {
                client_id: mdCompEvent.client_id ? mdCompEvent.client_id : mdCompEvent
            };
        if (this.salesbillentrydata['tabParams'] == 'EMI') {
            return;
        }
        this.salesBillentryService
            .getExistAdvClient(data)
            .then(function (res: any) {
                //that.clientList = res;
                if (res.totCnt > 0) {
                    swal({
                        title: 'Previous Advance is Still Pending,you want to Continue?',
                        text: 'Advance Amount: ' + res.data[0].oldadvances,
                        showCancelButton: true,
                        confirmButtonText: 'Yes, Continue!',
                        cancelButtonText: 'No, Cancel'
                    }).then(function () {
                        that.salesbillentrydata['adv_bill_id'] = res.data[0].adv_bill_id;
                        //that.salesbillentrydata['bill_type'] = res.data[0].bill_type;
                        that.salesbillentrydata['bill_id'] = res.data[0].adv_bill_id;

                        // that.salesbillentrydata['discount_percentage'] = res.data[0].discount_percentage;
                        // that.salesbillentrydata['discount_amount'] = res.data[0].discount_amount;
                        that.salesbillentrydata['initial_amount'] = res.data[0].initial_amount;
                        if (that.salesbillentrydata['tabParams'] != "Advance") {
                            that.salesbillentrydata['advances'] = res.data[0].oldadvances;
                        }
                        if (that.salesbillentrydata['tabParams'] == 'Advance') {
                            that.salesbillentrydata['oldadvances'] = res.data[0].oldadvances;
                            that.salesbillentrydata['gross_total'] = res.data[0].gross_total;
                            that.salesbillentrydata['amount'] = res.data[0].amount;
                            that.salesbillentrydata['less_amount'] = res.data[0].less_amount;
                            that.getSalesbillentryDetailList();
                            that.salesbillentrydata['hide_col'] = true;
                        }
                        that.calGrantTotal('all');
                    }
                        // , function (dismiss) {
                        //     if (that.salesbillentrydata['tabParams'] == 'Advance') {
                        //         that.salesbillentrydata['client_name'] = '';
                        //         that.salesbillentrydata['client_id'] = '';
                        //     }
                        // }
                    );
                }
            });
        let selectedClientId = mdCompEvent.client_id ? mdCompEvent.client_id : mdCompEvent;
        this.fetchClientPoints(selectedClientId);
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(nextEl))) {
            nextEl = 'empid';
        }
        $('#' + nextEl).focus();
    }

    onDeleteSalesbillentry(row: any): void {
        let that = this,
            mode = this._params['mode'];

        if (this.salesbillentrydata['hide_col'] == true) {
            swal('WARNING', 'Previous Advance Bill is in Progress, so You can not Deleted Any Model in this Transaction!');
            return;
        }
        if (mode == 'Add') {
            this.salesBillentryDetails.splice(this.salesBillentryDetails.indexOf(row), 1);
            //this.salesBillgriddata = [];
            this.calGrossTotal();
        } else {
            let branch_id = 0;
            if (this.salesbillentrydata['tabParams'] == 'HV' || this.salesbillentrydata['tabParams'] == 'SOA') {
                branch_id = this.salesbillentrydata['branch'];
            }
            let params = {
                model_id: row.model_id,
                name: row.name,
                mrp: row.mrp,
                quantity: row.quantity,
                rate: row.rate,
                amount: row.amount,
                bill_id: row.bill_id,
                bill_type: this.salesbillentrydata['tabParams'],
                client_id: this.salesbillentrydata['client_id'],
                challan_out_id: row['challan_out_id'],
                serial_no: row['serial_no'],
                ha_model_branch: row['act_branch_id'],
                branch_id
            };
            swal({
                title: 'Are you sure to Delete?',
                text: 'You will not be able to Recover this Machine Details: ' + row['name'],
                showCancelButton: true,
                confirmButtonText: 'Yes, Delete!',
                cancelButtonText: 'No, Cancel...'
            }).then(function () {
                that.isLoadMask = that.salesBillentryService
                    .deleteGridList(params)
                    .then(function (res: any) {
                        that.isLoading = false;
                        if (res.success) {
                            that.salesBillentryDetails.splice(that.salesBillentryDetails.indexOf(row), 1);
                            swal('SUCCESS', res.message, 'success');
                            if (that.salesbillentrydata['tabParams'] != 'HV' && that.salesbillentrydata['tabParams'] != 'SOA') {
                                that.loadChallanHaList();
                            } else {
                                that.onSelectedHVClient(that.salesbillentrydata['client_id'], 0);
                            }
                            that.getSalesbillentryDetailList();
                            that.calGrossTotal();

                        } else {
                            swal('ERROR', res.message, 'error');
                        }
                    });

            }, function (dismiss) {

            });
        }
    }

    addSalesbillentry(): void {
        // if (this.salesBillgriddata['stock_type'] != 'Spare' && this._params['tabParams'] != 'Advance' && this._params['tabParams'] != 'Spare Bill') {
        this.salesBillgriddata['model_id'] = this.salesBillgriddata['model_id']['model_id'];

        // }
        if (this._params['tabParams'] == 'HV' || this._params['tabParams'] == 'SOA') {
            this.salesBillgriddata['serial_no'] = this.salesBillgriddata['serial_no']['serial_no'];
        }
        let that = this,
            mode = this.salesbillentrydata['mode'],
            modelID = this.salesBillgriddata['model_id'],
            modelName = this.salesBillgriddata['name'],
            serialNo = this.salesBillgriddata['serial_no'],
            freeItem = this.salesBillgriddata['free_item'];
        // hsnCode = this.salesBillgriddata['hsn_code'];
        if (!_.isEmpty(_.toString(modelID))) {//} != undefined) {
            //IF preTestID FOUND, THAT ID IS ALREDAY AVAILABLE INSIDE TABLE
            let preTestID = _.find(this.salesBillentryDetails, { 'model_id': modelID, 'serial_no': serialNo });

            if (this._params['tabParams'] != 'Advance') {
                if (preTestID) {
                    swal('WARNING', 'Model : ' + modelName + ', Serial NO: ' + serialNo + ' Already Exists');
                    return;
                }
            }

            //TO CHECK STOCK AVAILABLE
            let modelObj = _.find(this.haList, { 'model_id': modelID });
            if (_.isEmpty(modelObj)) {
                swal('WARNING', 'Model : ' + modelName + ' Not Exists');
                return;
            }
            //TO CHECK SERIAL NO EXISTS IN THAT MODEL
            let serialNoList = this.serialNoList,
                currSerialNoObj = _.find(serialNoList, { 'model_id': modelID, 'serial_no': serialNo });
            if (this._params['tabParams'] == 'Advance') {
                currSerialNoObj = _.find(serialNoList, { 'model_id': modelID });
            }
            if (_.isEmpty(currSerialNoObj) && this._params['tabParams'] != 'Advance') {
                swal('WARNING', 'Serial No : ' + serialNo + ' Does Not Exists in This Model');
                return;
            }

            if (this._params['tabParams'] != 'Advance') {
                let availQty = currSerialNoObj['avail_qty'],
                    enteredQty = this.salesBillgriddata['quantity'];
                if (_.toNumber(enteredQty) > _.toNumber(availQty)) { // 11 > 10
                    swal('WARNING', 'Serial No: ' + serialNo + ' does not have Sufficient Quantity in Stock');
                    return;
                }
            }

            if (_.isEmpty(freeItem)) {
                swal('WARNING', 'Select Free Option Yes Or No');
                return;
            }
            if (freeItem != 'No' && (this._params['tabParams'] == 'Advance' || this._params['tabParams'] == 'Spare Bill')) {
                swal('WARNING', 'In ' + this._params['tabParams'] + ' , Free Items can not be Added!');
                return;
            }
            if (this.salesbillentrydata['hide_col'] == true) {
                swal('WARNING', 'Previous Advance Bill is in Progress, so You can not Add Any Model to this Transaction!');
                return;
            }
            // if (this._params['tabParams'] == 'Advance') {
            //     // // let serialNo = JSON.stringify(this.salesBillgriddata['serial_no']);
            //     // this.salesBillgriddata['serial_no'] = this.salesBillgriddata['serial_no'].serial_no;
            //     this.salesBillgriddata['serial_no'] = this.salesBillgriddata['serial_no'].serial_no;
            // }
            if (mode == 'Add') {
                let testDet = Object.assign({}, this.salesBillgriddata);
                this.salesBillentryDetails.push(testDet);
                if (this.salesBillentryDetails.length > 0) {
                    this.salesBillgriddata['model_id'] = '',
                        this.salesBillgriddata['name'] = '',
                        this.salesBillgriddata['mrp'] = '',
                        this.salesBillgriddata['rate'] = '',
                        this.salesBillgriddata['quantity'] = '',
                        this.salesBillgriddata['amount'] = '',
                        this.salesBillgriddata['serial_no'] = '',
                        this.salesBillgriddata['challan_out_id'] = '',
                        this.salesBillgriddata['tax_per'] = '',
                        this.salesBillgriddata['ha_model_branch'] = '',
                        this.salesBillgriddata['serialno_branch'] = '',
                        this.salesBillgriddata['challan_no'] = '',
                        this.salesBillgriddata['series_name'] = '',
                        this.salesBillgriddata['performance_name'] = '',
                        this.salesBillgriddata['family_name'] = '',
                        this.salesBillgriddata['battery_name'] = '',
                        this.salesBillgriddata['tele_audiology'] = ''
                }
                //this.salesbillentrydata['warranty_type'] = '';
                this.salesBillgriddata['amount'] = 0;
                if (this.salesbillentrydata['tabParams'] == 'Spare Bill' || this.salesbillentrydata['tabParams'] == 'Sales Bill' || this.salesbillentrydata['tabParams'] == 'HV' || this.salesbillentrydata['tabParams'] == 'SOA') {
                    this.salesBillgriddata['free_item'] = "No";
                    this.salesBillgriddata['model_id'] = "";
                    this.salesBillgriddata['serial_no'] = "";
                }
                that.page.count = this.salesBillentryDetails.length;
                that.calGrossTotal();
                //this.serialNoList = [];
            } else {
                let params: any;
                let testDet: any;
                let branch_id = 0;
                if (this.salesbillentrydata['tabParams'] == 'HV' || this.salesbillentrydata['tabParams'] == 'SOA') {
                    branch_id = this.salesbillentrydata['branch'];
                }
                // if (mode == 'Edit') {
                // params = {
                //     model_id: this.salesBillgriddata['model_id'],
                //     name: this.salesBillgriddata['name'],
                //     mrp: this.salesBillgriddata['mrp'],
                //     rate: this.salesBillgriddata['rate'],
                //     quantity: this.salesBillgriddata['quantity'],
                //     free_item: this.salesBillgriddata['free_item'],
                //     amount: this.salesBillgriddata['amount'],
                //     bill_id: this.salesbillentrydata['bill_id'],
                //     bill_type: this.salesbillentrydata['bill_type'],
                //     client_id: this.salesbillentrydata['client_id'],
                //     serial_no: this.salesBillgriddata['serial_no'],
                //     challan_out_id: that.salesBillgriddata['challan_out_id'],
                //     tax_per: that.salesBillgriddata['tax_per'],
                //     ha_model_branch: that.salesBillgriddata['ha_model_branch'],
                //     serialno_branch: that.salesBillgriddata['serialno_branch'],
                //     challan_no: that.salesBillgriddata['challan_no'],
                //     brand_id: this.salesBillgriddata['brand_id'] ? this.salesBillgriddata['brand_id'] : 0,
                //     brand_model_id: this.salesBillgriddata['brand_model_id'] ? this.salesBillgriddata['brand_model_id'] : 0,
                //     family_id: this.salesBillgriddata['family_id'] ? this.salesBillgriddata['family_id'] : 0,
                //     series_id: this.salesBillgriddata['series_id'] ? this.salesBillgriddata['series_id'] : 0,
                //     performance_id: this.salesBillgriddata['performance_id'] ? this.salesBillgriddata['performance_id'] : 0,
                //     power_id: this.salesBillgriddata['power_id'] ? this.salesBillgriddata['power_id'] : 0,
                //     battery_id: this.salesBillgriddata['battery_id'] ? this.salesBillgriddata['battery_id'] : 0,
                //     // hsn_code: that.salesBillgriddata['hsn_code'],
                //     branch_id
                // };



                testDet = Object.assign({}, this.salesBillgriddata);

                this.salesBillentryDetails.push(testDet);
                if (this.salesBillentryDetails.length > 0) {
                    this.salesBillgriddata['model_id'] = '',
                        this.salesBillgriddata['name'] = '',
                        this.salesBillgriddata['mrp'] = '',
                        this.salesBillgriddata['rate'] = '',
                        this.salesBillgriddata['quantity'] = '',
                        this.salesBillgriddata['amount'] = '',
                        this.salesBillgriddata['serial_no'] = '',
                        this.salesBillgriddata['challan_out_id'] = '',
                        this.salesBillgriddata['tax_per'] = '',
                        this.salesBillgriddata['ha_model_branch'] = '',
                        this.salesBillgriddata['serialno_branch'] = '',
                        this.salesBillgriddata['challan_no'] = '',
                        this.salesBillgriddata['series_name'] = '',
                        this.salesBillgriddata['performance_name'] = '',
                        this.salesBillgriddata['family_name'] = '',
                        this.salesBillgriddata['battery_name'] = '',
                        this.salesBillgriddata['tele_audiology'] = ''
                }
                //this.salesbillentrydata['warranty_type'] = '';
                this.salesBillgriddata['amount'] = 0;
                if (this.salesbillentrydata['tabParams'] == 'Spare Bill' || this.salesbillentrydata['tabParams'] == 'Sales Bill' || this.salesbillentrydata['tabParams'] == 'HV' || this.salesbillentrydata['tabParams'] == 'SOA') {
                    this.salesBillgriddata['free_item'] = "No";
                    this.salesBillgriddata['model_id'] = "";
                    this.salesBillgriddata['serial_no'] = "";
                }
                that.page.count = this.salesBillentryDetails.length;
                that.calGrossTotal();



                // } else if (this._params['mode'] == 'Exchange' || this._params['mode'] == 'Replacement') {
                //     params = {
                //         model_id: this.salesBillgriddata['model_id'],
                //         name: this.salesBillgriddata['name'],
                //         mrp: this.salesBillgriddata['mrp'],
                //         rate: this.salesBillgriddata['rate'],
                //         quantity: this.salesBillgriddata['quantity'],
                //         free_item: this.salesBillgriddata['free_item'],
                //         amount: this.salesBillgriddata['amount'],
                //         bill_id: this.salesbillentrydata['bill_id'],
                //         bill_type: this._params['mode'],
                //         client_id: this.salesbillentrydata['client_id'],
                //         serial_no: this.salesBillgriddata['serial_no'],
                //         challan_out_id: that.salesBillgriddata['challan_out_id'],
                //         tax_per: that.salesBillgriddata['tax_per'],
                //         ha_model_branch: that.salesBillgriddata['ha_model_branch'],
                //         serialno_branch: that.salesBillgriddata['serialno_branch'],
                //         challan_no: that.salesBillgriddata['challan_no'],
                //         // hsn_code: that.salesBillgriddata['hsn_code'],
                //         branch_id
                //     };
                // }

                // this.salesBillentryService
                //     .addSalesBillentry(params)
                //     .then(function (res: any) {
                //         that.isLoading = false;
                //         if (res.success) {
                //             swal('SUCCESS', res.message, 'success');
                //             if (that.salesbillentrydata['tabParams'] != 'HV' && that.salesbillentrydata['tabParams'] != 'SOA') {
                //                 that.loadChallanHaList();
                //             } else {
                //                 that.onSelectedHVClient(that.salesbillentrydata['client_id'], 0);
                //             }
                // that.salesBillentryDetails.push(testDet);
                // that.salesBillgriddata = [];
                //             that.salesBillgriddata['amount'] = 0;
                //             that.page.count = that.salesBillentryDetails.length;
                //             //that.salesBillgriddata = [];
                //             //  that.calAmount();
                //             that.calGrossTotal();
                //             that.getSalesbillentryDetailList();
                //         } else {
                //             swal('ERROR', res.message, 'error');
                //         }
                //     })
            }
        }
    }
    calAmount() {
        let qty = this.salesBillgriddata['quantity'],
            rte = this.salesBillgriddata['rate'],
            amt = 0;

        if (!_.isEmpty(_.toString(rte))) {
            amt = (qty * rte);
        }
        this.salesBillgriddata['amount'] = amt;
    }
    calGrossTotal(from?: string) {
        // let disPer = this.salesbillentrydata['discount_percentage'] || 0;
        // if (from && from == "dis_amt") {
        //     disPer = (this.salesbillentrydata['discount_amount'] / this.salesbillentrydata['mrpAmt']) * 100;
        //     disPer = (disPer.toFixed(2)) / 1;
        // }
        let disPer = 0; // FOR IGNORING DISCOUNT IN GRID

        let gross_total = 0,
            free_amt = 0,
            free = '',
            mrpAmt = 0;

        for (let i = 0; i < this.salesBillentryDetails.length; i++) {
            // const disAmt = (Number(this.salesBillentryDetails[i].mrp) * disPer) / 100;
            // const grossAmt = Number(this.salesBillentryDetails[i].mrp) - disAmt;
            // this.salesBillentryDetails[i].rate = Math.round(((grossAmt) * (parseFloat(this.salesBillentryDetails[i].tax_per)) / (100)) + (grossAmt));
            // // this.salesBillentryDetails[i].amount = this.salesBillentryDetails[i].quantity * this.salesBillentryDetails[i].rate;
            // this.salesBillentryDetails[i].amount = this.salesBillentryDetails[i].quantity * this.salesBillentryDetails[i].rate;


            // // const disAmt = (Number(this.salesBillentryDetails[i].mrp) * disPer) / 100;
            // const grossAmt = Number(this.salesBillentryDetails[i].mrp);
            // this.salesBillentryDetails[i].rate = Math.round(((grossAmt) * (parseFloat(this.salesBillentryDetails[i].tax_per)) / (100)) + (grossAmt));
            // // this.salesBillentryDetails[i].amount = this.salesBillentryDetails[i].quantity * this.salesBillentryDetails[i].rate;
            // this.salesBillentryDetails[i].amount = this.salesBillentryDetails[i].quantity * this.salesBillentryDetails[i].rate;



            // ...............................1
            // const disAmt =  Math.round((Number(this.salesBillentryDetails[i].mrp) * disPer) / 100);
            // // const grossAmt = Number(this.salesBillentryDetails[i].mrp) - disAmt;
            // let gstAmt;
            // let oneQuantityRate =  Math.round((this.salesBillentryDetails[i].quantity * this.salesBillentryDetails[i].mrp - disAmt) / this.salesBillentryDetails[i].quantity);
            // const grossAmt = oneQuantityRate * this.salesBillentryDetails[i].quantity;
            // gstAmt = Math.round(((oneQuantityRate * this.salesBillentryDetails[i].quantity) * (parseFloat(this.salesBillentryDetails[i].tax_per)) / 100) + (oneQuantityRate * this.salesBillentryDetails[i].quantity))

            // this.salesBillentryDetails[i].rate = Math.round(((grossAmt) * (parseFloat(this.salesBillentryDetails[i].tax_per)) / (100)) + (grossAmt));
            // // this.salesBillentryDetails[i].rate = Math.round(((oneQuantityRate) * (parseFloat(this.salesBillentryDetails[i].tax_per)) / (100)) + (oneQuantityRate));

            // // this.salesBillentryDetails[i].amount = this.salesBillentryDetails[i].quantity * this.salesBillentryDetails[i].rate;

            // this.salesBillentryDetails[i].amount =  Math.round(this.salesBillentryDetails[i].quantity * oneQuantityRate);
            // // this.salesBillentryDetails[i].amount = this.salesBillentryDetails[i].amount -disAmt;
            // // this.salesBillentryDetails[i].rate = oneQuantityRate;
            // // this.salesBillentryDetails[i].rate = this.salesBillentryDetails[i].amount / this.salesBillentryDetails[i].quantity;
            // console.log(this.salesBillentryDetails[i]);

            ////////////////////////////////////////////

            // /..........................................2

            const disAmt = Math.round((this.salesBillentryDetails[i].mrp * disPer) / 100);

            const mrp = Number(this.salesBillentryDetails[i].mrp);
            const quantity = Number(this.salesBillentryDetails[i].quantity);
            const taxPer = parseFloat(this.salesBillentryDetails[i].tax_per || 0); // GST percentage
            // const oneQuantityRate = Math.round(((mrp * quantity) - disAmt) / quantity);
            const oneQuantityRate = ((mrp * quantity) - disAmt) / quantity;

            // Step 3: Calculate gross amount for all items
            const grossAmt = oneQuantityRate * quantity;

            // Step 4: Calculate GST amount
            const gstAmt = Math.round((grossAmt * taxPer) / 100);
            // const oneQtyRate = oneQuantityRate +  Math.round((oneQuantityRate * taxPer) / 100);
            const oneQtyRate = Math.round(oneQuantityRate + (oneQuantityRate * taxPer) / 100);


            this.salesBillentryDetails[i].rate = oneQtyRate; // Final rate with GST
            this.salesBillentryDetails[i].amount = this.salesBillentryDetails[i].quantity * this.salesBillentryDetails[i].rate; // Final amount for the quantity
            // this.salesBillentryDetails[i].amount = this.salesBillentryDetails[i].quantity * this.salesBillentryDetails[i].rate + gstAmt; // Final amount for the quantity

            ////////////////////////////////////////////////


            let amount = Number(this.salesBillentryDetails[i].amount);
            let free_item = this.salesBillentryDetails[i].free_item;
            gross_total += Number(amount);
            mrpAmt += Number(this.salesBillentryDetails[i].mrp);
            free = free_item;
            if (free == 'Yes')
                free_amt += amount;

        }
        this.salesbillentrydata['gross_total'] = gross_total;
        this.salesbillentrydata['mrpAmt'] = mrpAmt;
        //this.salesbillentrydata['free_item'] = free;
        this.salesbillentrydata['less_amount'] = free_amt;
        this.salesBillentryDetails = [...this.salesBillentryDetails];
        if (!from) {
            this.calGrantTotal('all');
        } else {
            this.calGrantTotal(from);
        }
    }

    calGrantTotal(from_field) {
        let gross_total = this.salesbillentrydata['gross_total'],
            mrpAmt = this.salesbillentrydata['mrpAmt'],
            dis_per = this.salesbillentrydata['discount_percentage'],
            advances = this.salesbillentrydata['advances'],
            initial_amount = this.salesbillentrydata['initial_amount'],
            oldadvances = this.salesbillentrydata['oldadvances'],
            return_bill_amt = this.salesbillentrydata['return_bill_amt'],
            given_amount = this.salesbillentrydata['given_amount'],
            less = this.salesbillentrydata['less_amount'],
            discount_amount = this.salesbillentrydata['discount_amount'],
            redeem_discount = parseFloat(this.salesbillentrydata['redeem_discount']) || 0,
            coupon_discount = parseFloat(this.salesbillentrydata['coupon_discount']) || 0,
            grant_total = 0,
            gstotal = 0,
            total = 0;


        // if(from_field == 'dis_per'){
        //     //this.salesbillentrydata['discount_amount'] = 0;
        //     discount_amount = 0;
        // } else if(from_field == 'dis_amt'){
        //     //this.salesbillentrydata['discount_percentage'] = 0;
        //     dis_per = 0;
        // }

        if (_.isEmpty(_.toString(gross_total))) {
            gross_total = 0;
        }
        if (!_.isEmpty(_.toString(dis_per))) {
            if ((dis_per >= 0 && from_field == 'dis_per') || from_field == "all") {
                this.salesbillentrydata['discount_amount'] = 0;
                discount_amount = Number(((gross_total * dis_per) / 100).toFixed(2));

            }
        } else {
            dis_per = 0;
            discount_amount = 0;
        }
        if (!_.isEmpty(_.toString(discount_amount)) && discount_amount != 0) {
            if (from_field == 'dis_amt') {
                this.salesbillentrydata['discount_percentage'] = 0;//(parseFloat(discount_amount) / parseFloat(gross_total)) * 100;
                dis_per = (discount_amount / gross_total) * 100;
                dis_per = (dis_per.toFixed(2)) / 1;
            }

        } else {
            discount_amount = 0;
            dis_per = 0;
        }

        if (_.isEmpty(_.toString(advances))) {
            advances = 0;
        }
        if (_.isEmpty(_.toString(initial_amount))) {
            initial_amount = 0;
        }
        if (_.isEmpty(_.toString(oldadvances)) || this.salesbillentrydata['tabParams'] == "Sales Bill") {
            oldadvances = 0;
        }
        if (advances == undefined) {
            advances = 0;
        }
        if (oldadvances == undefined) {
            advances = 0;
        }
        if (_.isEmpty(_.toString(less))) {
            less = 0;
        }
        if (_.isEmpty(_.toString(return_bill_amt))) {
            return_bill_amt = 0;
        }
        if (_.isEmpty(_.toString(given_amount))) {
            given_amount = 0;
        }

        total = parseFloat(discount_amount);
        total = total + parseFloat(less);
        total = total + parseFloat(advances);
        total = total + parseFloat(oldadvances);
        total = total + parseFloat(initial_amount);
        total = total + parseFloat(return_bill_amt);
        total = total + redeem_discount;
        total = total + coupon_discount;
        gstotal = parseFloat(gross_total) + given_amount;
        // grant_total = gstotal;
        // grant_total = gstotal - less;
        grant_total = gstotal - total;


        //grant_total = (parseFloat(gross_total) - parseFloat(discount_amount + less)) - (parseFloat(advances) + parseFloat(oldadvances) + parseFloat(initial_amount));


        // if (!_.isEmpty(_.toString(gross_total))) {
        //     grant_total = gross_total - discount_amount;
        // }
        // if (!_.isEmpty(_.toString(advances))) {
        //     grant_total = (gross_total - discount_amount) - advances;
        // }
        this.salesbillentrydata['discount_percentage'] = dis_per;
        this.salesbillentrydata['discount_amount'] = discount_amount;
        this.salesbillentrydata['less_amount'] = less;
        this.salesbillentrydata['amount'] = grant_total;
    }
    bsModalRef: BsModalRef;

    // FOR ADDING NEW ENTRIES WHEN EDITING
    async manageNewEntries(response: any) {
        let that = this;
        let branch_id = 0;
        let params = {};
        let mode = this.salesbillentrydata['mode'];
        if (this.salesbillentrydata['tabParams'] == 'HV' || this.salesbillentrydata['tabParams'] == 'SOA') {
            branch_id = this.salesbillentrydata['branch'];
        }
        const newEntries = this.salesBillentryDetails.filter((data) => !data.bill_id);
        if (newEntries.length) {
            newEntries.forEach(async (data, index) => {
                if (mode == 'Edit') {
                    params = {
                        model_id: data['model_id'],
                        name: data['name'],
                        mrp: data['mrp'],
                        rate: data['rate'],
                        quantity: data['quantity'],
                        free_item: data['free_item'],
                        amount: data['amount'],
                        bill_id: this.salesbillentrydata['bill_id'],
                        bill_type: this.salesbillentrydata['bill_type'],
                        client_id: this.salesbillentrydata['client_id'],
                        serial_no: data['serial_no'],
                        challan_out_id: data['challan_out_id'],
                        tax_per: data['tax_per'],
                        ha_model_branch: data['ha_model_branch'],
                        serialno_branch: data['serialno_branch'],
                        challan_no: data['challan_no'],
                        brand_id: data['brand_id'] ? data['brand_id'] : 0,
                        brand_model_id: data['brand_model_id'] ? data['brand_model_id'] : 0,
                        family_id: data['family_id'] ? data['family_id'] : 0,
                        series_id: data['series_id'] ? data['series_id'] : 0,
                        performance_id: data['performance_id'] ? data['performance_id'] : 0,
                        power_id: data['power_id'] ? data['power_id'] : 0,
                        battery_id: data['battery_id'] ? data['battery_id'] : 0,
                        color_id: data['color_id'] ? data['color_id'] : 0,
                        branch_id
                    };
                } else if (this._params['mode'] == 'Exchange' || this._params['mode'] == 'Replacement') {
                    params = {
                        model_id: data['model_id'],
                        name: data['name'],
                        mrp: data['mrp'],
                        rate: data['rate'],
                        quantity: data['quantity'],
                        free_item: data['free_item'],
                        amount: data['amount'],
                        bill_id: this.salesbillentrydata['bill_id'],
                        bill_type: this._params['mode'],
                        client_id: this.salesbillentrydata['client_id'],
                        serial_no: data['serial_no'],
                        challan_out_id: data['challan_out_id'],
                        tax_per: data['tax_per'],
                        ha_model_branch: data['ha_model_branch'],
                        serialno_branch: data['serialno_branch'],
                        challan_no: data['challan_no'],
                        // hsn_code: data['hsn_code'],
                        branch_id
                    };
                }

                await this.salesBillentryService.addSalesBillentry(params).then(
                    function (res: any) {
                        if (res.success) {
                            if (index == newEntries.length - 1) {
                                that.close(response);
                            }
                        } else {
                            swal('ERROR', res.message, 'error');
                        }
                    });
            });
        } else {
            this.close(response);
        }
    }

    // async updateEntries() {
    //     let that = this;
    //     let branch_id = 0;
    //     if (this.salesbillentrydata['tabParams'] == 'HV' || this.salesbillentrydata['tabParams'] == 'SOA') {
    //         branch_id = this.salesbillentrydata['branch'];
    //     }

    //     const oldEntries = this.salesBillentryDetails.filter((data) => data.bill_id);
    //     if (oldEntries.length) {
    //         oldEntries.forEach(async (data, index) => {
    //             let params = {
    //                 model_id: data.model_id,
    //                 name: data.name,
    //                 mrp: data.mrp,
    //                 quantity: data.quantity,
    //                 rate: data.rate,
    //                 amount: data.amount,
    //                 bill_id: data.bill_id,
    //                 bill_type: this.salesbillentrydata['tabParams'],
    //                 client_id: this.salesbillentrydata['client_id'],
    //                 challan_out_id: data['challan_out_id'],
    //                 serial_no: data['serial_no'],
    //                 ha_model_branch: data['act_branch_id'],
    //                 branch_id
    //             };

    //             await that.salesBillentryService
    //                 .deleteGridList(params)
    //                 .then(function (res: any) {
    //                     that.isLoading = false;
    //                     if (res.success) {
    //                         console.log('deleted-success');
    //                         if(index == oldEntries.length - 1) {
    //                             that.manageNewEntries();
    //                         }
    //                     } else {
    //                         alert("deleted-alert");
    //                     }
    //                 });
    //         });
    //     } else {
    //         this.manageNewEntries();
    //     }
    // }

    requiresMultipleAmountFields(paymentTypes: any): boolean {
        if (Array.isArray(paymentTypes)) {
            return paymentTypes.length >= 2;
        }
        return false;
    }

    validateMultipleAmounts(): void {
        if (!this.requiresMultipleAmountFields(this.salesbillentrydata['type'])) {
            return;
        }

        let totalAmount = 0;
        const paymentTypes = this.salesbillentrydata['type'];

        if (paymentTypes.includes('CASH') && this.salesBillgriddata['cash_amt']) {
            totalAmount += parseFloat(this.salesBillgriddata['cash_amt']) || 0;
        }
        if (paymentTypes.includes('CARD') && this.salesBillgriddata['card_amt']) {
            totalAmount += parseFloat(this.salesBillgriddata['card_amt']) || 0;
        }
        if (paymentTypes.includes('ONLINE') && this.salesBillgriddata['online_amt']) {
            totalAmount += parseFloat(this.salesBillgriddata['online_amt']) || 0;
        }
        if (paymentTypes.includes('CHEQUE') && this.salesBillgriddata['cheque_amt']) {
            totalAmount += parseFloat(this.salesBillgriddata['cheque_amt']) || 0;
        }
        if (paymentTypes.includes('CREDIT') && this.salesBillgriddata['credit_amt']) {
            totalAmount += parseFloat(this.salesBillgriddata['credit_amt']) || 0;
        }

        this.salesBillgriddata['total_payment_amount'] = totalAmount;
    }

    async onSaveSalesbillentry() {
        let that = this,
            mode = this.salesbillentrydata['mode'],
            advance = this.salesbillentrydata['advances'],
            initial_amount = this.salesbillentrydata['initial_amount'],
            salesBillentry = this.salesBillentryDetails.length,
            qty = 0,
            cash_amount = this.salesBillgriddata['cash_amt'],
            card_amount = this.salesBillgriddata['card_amt'],
            credit_amount = this.salesBillgriddata['credit_amt'],
            online_amount = this.salesBillgriddata['online_amt'],
            cheque_amount = this.salesBillgriddata['cheque_amt'],
            model_warranty = this.salesBillgriddata['warranty_type']


        if (_.isEmpty(_.toString(this.salesbillentrydata['client_id']))) {
            swal('WARNING', 'Please Select Client ID');
            return;
        }
        if (this.salesbillentrydata['amount'] < 0) {
            swal('WARNING', 'Please Enter Valid Amount');
            return;
        }
        /* if (this.salesbillentrydata['tabParams'] == 'Advance') {
            if (_.isEmpty(_.toString(advance))) {
                swal('WARNING', 'Please Enter Advance Amount');
                return;
            } else if (advance <= 0) {
                swal('WARNING', 'Please Enter Valid Advance Amount');
                return;
            }
        } */
        if (this.salesbillentrydata['tabParams'] == 'EMI') {
            if (_.isEmpty(_.toString(initial_amount))) {
                swal('WARNING', 'Please Enter Initial Amount');
                return;
            } else if (initial_amount <= 0) {
                swal('WARNING', 'Please Enter Valid Initial Amount');
                return;
            }
        }
        if (_.isEmpty(_.toString(this.salesbillentrydata['type']))) {
            swal('WARNING', 'Please Select Type');
            return;
        }
        if (salesBillentry == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Model Details');
            return;
        }
        // Validate Cheque No if CHEQUE is selected
        if (this.requiresChequeNo(this.salesbillentrydata['type'])) {
            if (_.isEmpty(_.toString(this.salesbillentrydata['chqno']))) {
                swal('WARNING', 'Please Enter Cheque Number');
                return;
            }
        }

        // Validate Online NO if ONLINE is selected  
        if (this.requiresTransactionNo(this.salesbillentrydata['type'])) {
            if (_.isEmpty(_.toString(this.salesbillentrydata['onlineno']))) {
                swal('WARNING', 'Please Enter Online No');
                return;
            }
        }

        // Validate multiple payment amounts if multiple payment types are selected
        if (this.requiresMultipleAmountFields(this.salesbillentrydata['type'])) {
            const paymentTypes = this.salesbillentrydata['type'];
            let totalPaymentAmount = 0;
            let missingAmounts = [];

            // Check each selected payment type has corresponding amount
            if (paymentTypes.includes('CASH')) {
                if (_.isEmpty(_.toString(this.salesBillgriddata['cash_amt'])) || this.salesBillgriddata['cash_amt'] <= 0) {
                    missingAmounts.push('Cash Amount');
                } else {
                    totalPaymentAmount += parseFloat(this.salesBillgriddata['cash_amt']);
                }
            }
            if (paymentTypes.includes('CARD')) {
                if (_.isEmpty(_.toString(this.salesBillgriddata['card_amt'])) || this.salesBillgriddata['card_amt'] <= 0) {
                    missingAmounts.push('Card Amount');
                } else {
                    totalPaymentAmount += parseFloat(this.salesBillgriddata['card_amt']);
                }
            }
            if (paymentTypes.includes('ONLINE')) {
                if (_.isEmpty(_.toString(this.salesBillgriddata['online_amt'])) || this.salesBillgriddata['online_amt'] <= 0) {
                    missingAmounts.push('Online Amount');
                } else {
                    totalPaymentAmount += parseFloat(this.salesBillgriddata['online_amt']);
                }
            }
            if (paymentTypes.includes('CHEQUE')) {
                if (_.isEmpty(_.toString(this.salesBillgriddata['cheque_amt'])) || this.salesBillgriddata['cheque_amt'] <= 0) {
                    missingAmounts.push('Cheque Amount');
                } else {
                    totalPaymentAmount += parseFloat(this.salesBillgriddata['cheque_amt']);
                }
            }
            if (paymentTypes.includes('CREDIT')) {
                if (_.isEmpty(_.toString(this.salesBillgriddata['credit_amt'])) || this.salesBillgriddata['credit_amt'] <= 0) {
                    missingAmounts.push('Credit Amount');
                } else {
                    totalPaymentAmount += parseFloat(this.salesBillgriddata['credit_amt']);
                }
            }

            // Check if any amounts are missing
            if (missingAmounts.length > 0) {
                swal('WARNING', 'Please enter valid amounts for: ' + missingAmounts.join(', '));
                return;
            }

            // Validate that total payment amounts equal grand total
            const grandTotal = this.salesbillentrydata['amount'];
            const targetAmount = this.salesbillentrydata['tabParams'] == 'EMI' ? initial_amount :
                this.salesbillentrydata['tabParams'] == 'Advance' ? advance : grandTotal;

            if (Math.abs(totalPaymentAmount - targetAmount) > 0.01) { // Allow for small rounding differences
                swal('WARNING', `Total payment amounts (${totalPaymentAmount}) do not match the required amount (${targetAmount})`);
                return;
            }
        }

        // if (this.salesbillentrydata['type'] == 'CASH&CARD') {
        //     let tot = parseFloat(cash_amount) + parseFloat(card_amount);
        //     if(this.salesbillentrydata['tabParams'] == 'EMI')
        //     {
        //         if (initial_amount == tot) {
        //             this.salesbillentrydata['initial_amount'] = tot;
        //         } else {
        //             swal('WARNING', 'Initial Amount Does Not Match!!!');
        //             return;
        //         }
        //     }
        //     else if(this.salesbillentrydata['tabParams'] == 'Advance')
        //     {
        //         if (advance == tot) {
        //             this.salesbillentrydata['advances'] = tot;
        //         } else {
        //             swal('WARNING', 'Advance Amount Does Not Match!!!');
        //             return;
        //         }
        //     }
        //     else{
        //         if (this.salesbillentrydata['amount'] == tot) {
        //             this.salesbillentrydata['amount'] = tot;
        //         } else {
        //             swal('WARNING', ' Amount Does Not Match!!!');
        //             return;
        //         }
        //     }

        // }

        for (let i = 0; i < salesBillentry; i++) {
            qty += this.salesBillentryDetails[i].quantity;
        }

        //Get HA modelid for ater sales follow up 
        let ha_model_id = '';
        let branch_id = 0;
        if (this.salesbillentrydata['tabParams'] == 'Spare Bill' || this.salesbillentrydata['tabParams'] == 'Advance' || this.salesbillentrydata['tabParams'] == 'EMI') {
            branch_id = this.salesbillentrydata['branch'];
        }
        if (this.salesbillentrydata['tabParams'] == 'HV' || this.salesbillentrydata['tabParams'] == 'SOA') {

            this.salesBillentryDetails.forEach((el) => {
                ha_model_id += el.model_id + ","
            });
            ha_model_id = ha_model_id.slice(0, -1);
            branch_id = this.salesbillentrydata['branch'];
            this.loadAutoNumber();
        }


        let salesBillentryDate = moment(this.salesbillentrydata['date']).format('YYYY-MM-DD'),
            data = {
                bill_id: this.salesbillentrydata['bill_id'],
                auto_no: this.salesbillentrydata['auto_no'],
                date: salesBillentryDate,
                from_type: this.salesbillentrydata['from_type'],
                type: this.salesbillentrydata['type'],
                client_id: this.salesbillentrydata['client_id'],
                client_name: this.salesbillentrydata['client_name'],
                salesBillentryDetails: JSON.stringify(this.salesBillentryDetails),
                gross_total: this.salesbillentrydata['gross_total'],
                discount_percentage: this.salesbillentrydata['discount_percentage'],
                discount_amount: this.salesbillentrydata['discount_amount'],
                description: this.salesbillentrydata['description'],
                amount: this.salesbillentrydata['amount'],
                less_amount: this.salesbillentrydata['less_amount'],
                advances: advance,
                initial_amount: initial_amount,
                mode: this.salesbillentrydata['mode'],
                bill_type: this.salesbillentrydata['tabParams'],
                adv_bill_id: that.salesbillentrydata['adv_bill_id'],
                emiDetails: [],
                empid: that.salesbillentrydata['empid'],
                empid1: that.salesbillentrydata['empid1'],
                tot_qty: qty,
                chqno: this.salesbillentrydata['chqno'],
                onlineno: this.salesbillentrydata['onlineno'],
                bank: this.salesbillentrydata['bank'],
                gst: this.salesBillentryDetails['tax_per'],
                cash_amount,
                card_amount,
                credit_amount,
                online_amount,
                cheque_amount,
                payment_type: this.salesbillentrydata['payment_type'],
                return_bill_amt: this.salesbillentrydata['return_bill_amt'],
                given_amount: this.salesbillentrydata['given_amount'],
                transaction_type: this.salesbillentrydata['transaction_type'],
                return_id: this.salesbillentrydata['return_id'],
                //warranty: this.salesbillentrydata['warranty_type'],
                model_warranty,
                modelFrom_page: this.salesbillentrydata['ha_model_from_page'],
                advance_type: this.salesbillentrydata['advance_type'],
                travel_expense: this.salesbillentrydata['travel_expense'],
                testing: this.salesbillentrydata['testing'],
                user_role_type: this.salesbillentrydata['user_role_type'],
                ha_model_id,
                branch_id,
                machine_type: this.salesbillentrydata['machine_type'] || '',
                telecare_app_installed: this.salesbillentrydata['telecare_app_installed'] || 'no',
                roc_coupon_give: (this.salesbillentrydata['tabParams'] == 'EMI' || this.salesbillentrydata['tabParams'] == 'Spare Bill')
                                 ? (this.salesBillgriddata['roc_coupon_give'] || 'No')
                                 : (this.salesbillentrydata['roc_coupon_give'] || 'no'),
                roc_referral: this.salesbillentrydata['roc_referral'] || 'no',
                roc_referral_number: this.salesbillentrydata['roc_referral_number'] || '',
                google_review: this.salesbillentrydata['google_review'] || 'no',
                testimonial: this.salesbillentrydata['testimonial'] || 'no',
                contact_number_saved: this.salesbillentrydata['contact_number_saved'] || 'no',
                saved_contact_number: this.salesbillentrydata['saved_contact_number'] || '',
                uploaded_image: this.salesbillentrydata['uploaded_image'] || '',
                redeemed_points: this.salesbillentrydata['redeemed_points'] || 0,
                redemption_discount: this.salesbillentrydata['redemption_discount'] || 0,
                coupon_discount: this.salesbillentrydata['coupon_discount'] || 0,
                coupon_code: this.couponCodeInput || '',
                walkin_id: this.salesbillentrydata['walkin_id'] || 0
            };
        if (this._params['page_from'] == 'HV Appointment' || this._params['page_from'] == 'SOA Appointment') {
            data['ha_id'] = this.salesbillentrydata['ha_id'];
            data['st_det_id'] = this.salesbillentrydata['st_det_id'];
            data['hvoutprebooktype'] = this._params['page_from'];
        }

        if (this._params['page_from'] == 'HV Entry' || this._params['page_from'] == 'SOA Entry') {
            data['entryPageFromDet'] = this._params['page_from'];
        }

        if (this.salesbillentrydata['tabParams'] == "EMI") {
            that.bsModalRef = that.modalService.show(AddEditEmiDetailsComponent, {
                keyboard: false,
                ignoreBackdropClick: true,
                class: 'modal-lg theme-purple'
            });
            if (mode == 'Edit') {
                data['emiDetails'] = this.emiDetails;
            }
            that.bsModalRef.content.emiAlldata = Object.assign({}, data);
            return;
        }
        that.isLoading = true;
        this.salesBillentryService
            .addUpdatesalesBillentry(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    if (mode == "Edit") {
                        that.manageNewEntries(res);
                    } else {
                        that.close(res);
                    }
                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }

    close(res: any) {
        let that = this;
        that.salesbillentrydata = [];
        that.salesBillentryDetails = [];
        swal('SUCCESS', res.message, 'success');
        that.subscribeService.subScribeDeleteActiveTab();
        that.subscribeService.subReloadSalesBillentryListGrid();
        if (that._params['page_from'] == 'HV Appointment' || that._params['page_from'] == 'SOA Appointment') {
            that.subscribeService.subReloadAppointmentGrid();
        }
        if (that._params['page_from'] == 'HV Entry' || that._params['page_from'] == 'SOA Entry' || that._params['page_from'] == 'DR Promo' || that._params['page_from'] == 'SG Promo' || that._params['page_from'] == 'Store Promo') {
            that.subscribeService.subReloadClientWalkInGrid();
        }
    }

    filterTypes(name: string) {
        name = _.escapeRegExp(name);
        return this.testingList.filter(type => (new RegExp(name, 'gi').test(type.name)));
    }

    getTestingtypeList() {
        let that = this;
        this.commonService
            .getTestingtypeList()
            .then(function (res: any) {
                that.testingList = res;
                if (res.length > 0) {
                    if (that.testTravelRes.length > 0) {
                        that.testingtypeCtrl.setValue(Number(that.testTravelRes[0]['testing']));
                        that.salesbillentrydata['travel_expense'] = that.testTravelRes[0]['travel_expense'];
                    }
                }
            });
    }

    displayType(type_id: number) {
        if (type_id && this.testingList.length > 0) {
            let ftype = _.find(this.testingList, { 'id': type_id });
            return ftype['name'];
        }
        if (this._params['page_from'] == "HV Entry" || this._params['page_from'] == "SOA Entry" || this._params['page_from'] == "HV Appointment" || this._params['page_from'] == "SOA Appointment") {
            if (this._params['test_type_id'] && this.testingList.length > 0) {
                return this._params['test_type_name']
            }
            return this._params['test_type_name'];
        }
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }

    displayBranchFn(branchID: number) {
        if (branchID && this.branchList.length > 0) {
            let branchObj = _.find(this.branchList, { 'branch_id': parseInt(branchID.toString()) });
            return branchObj['branch_name'];
        }
        return '';
    }


    // Redemption Methods
    fetchClientPoints(client_id: any) {
        if (!client_id) { return; }
        this.salesBillentryService.getClientPointsForRedemption({ client_id: client_id, bill_amount: 0 })
            .then((res: any) => {
                if (res.success) {
                    this.clientAvailablePoints = res.data.total_points || 0;
                }
            }).catch(() => {});
    }

    openRedeemPointsDialog() {
        if (!(this.salesbillentrydata as any).client_id) {
            this.toasterService.pop('error', 'Error', 'Please select a client first');
            return;
        }

        // Get current bill amount
        const billAmount = (this.salesbillentrydata as any).amount || 0;

        // Fetch client points data
        this.salesBillentryService.getClientPointsForRedemption({
            client_id: (this.salesbillentrydata as any).client_id,
            bill_amount: billAmount
        }).then((res: any) => {
            if (res.success) {
                this.redemptionData = res.data;
                this.redemptionData.points_to_redeem = 0;
                this.redemptionData.discount_amount = 0;

                // Get financial year from store
                this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
                    this.financialYear = auth['finyear'] || '';
                });

                // Open modal
                this.redeemModalRef = this.modalService.show(this.redeemPointsModal, {
                    class: 'modal-lg',
                    backdrop: 'static'
                });
            } else {
                this.toasterService.pop('error', 'Error', res.message || 'Failed to fetch client points');
            }
        }).catch((error) => {
            console.error('Error fetching client points:', error);
            this.toasterService.pop('error', 'Error', 'Failed to fetch client points data');
        });
    }

    calculateDiscount() {
        const pointsToRedeem = parseFloat(this.redemptionData.points_to_redeem) || 0;
        const redeemValue = parseFloat(this.redemptionData.redeem_value) || 0;

        this.redemptionData.discount_amount = pointsToRedeem * redeemValue;
    }

    isRedemptionValid(): boolean {
        const pointsToRedeem = parseFloat(this.redemptionData.points_to_redeem) || 0;
        const totalPoints = parseFloat(this.redemptionData.total_points) || 0;

        // Check if points to redeem is valid
        if (pointsToRedeem <= 0) {
            return false;
        }

        // Check if exceeds available balance
        if (pointsToRedeem > totalPoints) {
            return false;
        }

        return true;
    }

    applyRedemption() {
        if (!this.isRedemptionValid()) {
            this.toasterService.pop('error', 'Error', 'Invalid redemption amount');
            return;
        }

        // Store redemption data in salesbillentrydata
        (this.salesbillentrydata as any)['redeemed_points'] = this.redemptionData.points_to_redeem;
        (this.salesbillentrydata as any)['redemption_discount'] = this.redemptionData.discount_amount;

        // Apply discount to redeem_discount field (separate from discount_amount)
        (this.salesbillentrydata as any)['redeem_discount'] = parseFloat(this.redemptionData.discount_amount) || 0;

        // Recalculate grand total
        this.calGrantTotal('redeem');

        this.toasterService.pop('success', 'Success', `${this.redemptionData.points_to_redeem} points redeemed successfully! Discount: ₹${this.redemptionData.discount_amount}`);

        // Close modal
        this.closeRedeemDialog();
    }

    closeRedeemDialog() {
        if (this.redeemModalRef) {
            this.redeemModalRef.hide();
        }
    }

    onRedeemCheckboxChange(checked: boolean) {
        if (checked) {
            if (!(this.salesbillentrydata as any).client_id) {
                this.toasterService.pop('error', 'Error', 'Please select a client first');
                (this.salesbillentrydata as any)['redeem_points_opted'] = false;
                return;
            }
            this.otpSent = false;
            this.otpVerified = false;
            this.otpValue = '';
            this.generateRedeemOtp();
        } else {
            this.otpSent = false;
            this.otpVerified = false;
            this.otpValue = '';
            (this.salesbillentrydata as any)['redeem_discount'] = 0;
            this.calGrantTotal('redeem');
        }
    }

    generateRedeemOtp() {
        const client_id = (this.salesbillentrydata as any).client_id;
        this.salesBillentryService.generateClientOtp({ client_id: client_id })
            .then((res: any) => {
                if (res.success) {
                    this.otpSent = true;
                    this.toasterService.pop('success', 'OTP Sent', res.message);
                } else {
                    this.toasterService.pop('error', 'Error', res.message || 'Failed to send OTP');
                    (this.salesbillentrydata as any)['redeem_points_opted'] = false;
                }
            }).catch(() => {
                this.toasterService.pop('error', 'Error', 'Failed to generate OTP');
                (this.salesbillentrydata as any)['redeem_points_opted'] = false;
            });
    }

    verifyRedeemOtp() {
        const client_id = (this.salesbillentrydata as any).client_id;
        this.salesBillentryService.verifyClientOtp({ client_id: client_id, otp: this.otpValue })
            .then((res: any) => {
                if (res.success) {
                    this.otpVerified = true;
                    this.toasterService.pop('success', 'Success', 'OTP verified! You can now redeem points.');
                } else {
                    this.toasterService.pop('error', 'Error', res.message || 'Invalid OTP');
                }
            }).catch(() => {
                this.toasterService.pop('error', 'Error', 'Failed to verify OTP');
            });
    }

    onCouponCheckboxChange(checked: boolean) {
        this.couponOtpSent = false;
        this.couponOtpVerified = false;
        this.couponOtpValue = '';
        if (checked) {
            if (!this.couponCodeInput || !this.couponCodeInput.trim()) {
                this.toasterService.pop('error', 'Error', 'Please enter a coupon code first');
                (this.salesbillentrydata as any)['coupon_opted'] = false;
                return;
            }
            if (!(this.salesbillentrydata as any).client_id) {
                this.toasterService.pop('error', 'Error', 'Please select a client first');
                (this.salesbillentrydata as any)['coupon_opted'] = false;
                return;
            }
            this.generateCouponOtp();
        } else {
            (this.salesbillentrydata as any)['coupon_discount'] = 0;
            this.calGrantTotal('coupon');
        }
    }

    generateCouponOtp() {
        const client_id = (this.salesbillentrydata as any).client_id;
        this.salesBillentryService.generateCouponOtp({ client_id: client_id })
            .then((res: any) => {
                if (res.success) {
                    this.couponOtpSent = true;
                    this.toasterService.pop('success', 'OTP Sent', res.message);
                } else {
                    this.toasterService.pop('error', 'Error', res.message || 'Failed to send OTP');
                    (this.salesbillentrydata as any)['coupon_opted'] = false;
                }
            }).catch(() => {
                this.toasterService.pop('error', 'Error', 'Failed to generate OTP');
                (this.salesbillentrydata as any)['coupon_opted'] = false;
            });
    }

    verifyCouponOtp() {
        const client_id = (this.salesbillentrydata as any).client_id;
        this.salesBillentryService.verifyCouponOtp({ client_id: client_id, otp: this.couponOtpValue })
            .then((res: any) => {
                if (res.success) {
                    const bill_amount = parseFloat((this.salesbillentrydata as any)['gross_total']) || 0;
                    this.salesBillentryService.validateCouponCode({ coupon_code: this.couponCodeInput, client_id: client_id, bill_amount: bill_amount })
                        .then((couponRes: any) => {
                            if (couponRes.success) {
                                this.couponOtpVerified = true;
                                (this.salesbillentrydata as any)['coupon_discount'] = parseFloat(couponRes.discount_amount) || 0;
                                this.couponDiscountType = couponRes.discount_type || 'Amount';
                                this.couponDiscountPercentage = parseFloat(couponRes.discount_percentage) || 0;
                                this.calGrantTotal('coupon');

                                let successMessage = couponRes.campaign_name + ': -₹' + couponRes.discount_amount;
                                if (this.couponDiscountType === 'Percentage') {
                                    successMessage += ` (${this.couponDiscountPercentage}%)`;
                                }
                                this.toasterService.pop('success', 'Coupon Applied', successMessage);
                            } else {
                                this.toasterService.pop('error', 'Invalid Coupon', couponRes.message);
                                (this.salesbillentrydata as any)['coupon_opted'] = false;
                                (this.salesbillentrydata as any)['coupon_discount'] = 0;
                            }
                        });
                } else {
                    this.toasterService.pop('error', 'Error', res.message || 'Invalid OTP');
                }
            }).catch(() => {
                this.toasterService.pop('error', 'Error', 'Failed to verify OTP');
            });
    }

    getCouponPlaceholder(): string {
        if (this.couponDiscountType === 'Percentage') {
            return `Coupon Amount (${this.couponDiscountPercentage}%)`;
        }
        return 'Coupon Amount';
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/salesBillentry/addEditSalesBillentry.component.ts